import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { ThemeProvider, makeStyles, darken, Box, DialogTitle, Typography, DialogContent, DialogActions, Button, CircularProgress, TextField } from '@material-ui/core';
import { environment, snackbarSlice, dialogsSlice, ecommerceApi, machineCloudApi, errorMiddleware, customTheme, SnackbarListener, DialogListener, ConfirmationDialog, FlexCentering, ecommerceTagTypes, ColoredCircle } from '@ventionco/machine-cloud-shared-components';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useDispatch, useSelector, Provider } from 'react-redux';
import { createSlice, combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { EstopStatus } from '@ventionco/machine-cloud-models';
import { useDyteClient, useDyteMeeting, useDyteSelector, DyteProvider } from '@dytesdk/react-web-core';
import React, { useRef, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { DyteMeeting, DyteControlbarButton } from '@dytesdk/react-ui-kit';
import ReactDOM from 'react-dom';
import { range } from 'lodash';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$C =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$c = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$b = fails$c;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$b(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$a = fails$c;

var functionBindNative = !fails$a(function () {
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$b = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$b.bind(call$b) : function () {
  return call$b.apply(call$b, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var bind$5 = FunctionPrototype$2.bind;
var call$a = FunctionPrototype$2.call;
var uncurryThis$f = NATIVE_BIND$2 && bind$5.bind(call$a, call$a);

var functionUncurryThis = NATIVE_BIND$2 ? function (fn) {
  return fn && uncurryThis$f(fn);
} : function (fn) {
  return fn && function () {
    return call$a.apply(fn, arguments);
  };
};

var uncurryThis$e = functionUncurryThis;

var toString$3 = uncurryThis$e({}.toString);
var stringSlice$1 = uncurryThis$e(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$1(toString$3(it), 8, -1);
};

var global$B = global$C;
var uncurryThis$d = functionUncurryThis;
var fails$9 = fails$c;
var classof$5 = classofRaw$1;

var Object$5 = global$B.Object;
var split = uncurryThis$d(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$9(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object$5('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$5(it) == 'String' ? split(it, '') : Object$5(it);
} : Object$5;

var global$A = global$C;

var TypeError$d = global$A.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw TypeError$d("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$i = function (argument) {
  return typeof argument == 'function';
};

var isCallable$h = isCallable$i;

var isObject$7 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$h(it);
};

var global$z = global$C;
var isCallable$g = isCallable$i;

var aFunction = function (argument) {
  return isCallable$g(argument) ? argument : undefined;
};

var getBuiltIn$7 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$z[namespace]) : global$z[namespace] && global$z[namespace][method];
};

var uncurryThis$c = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$c({}.isPrototypeOf);

var getBuiltIn$6 = getBuiltIn$7;

var engineUserAgent = getBuiltIn$6('navigator', 'userAgent') || '';

var global$y = global$C;
var userAgent$3 = engineUserAgent;

var process$3 = global$y.process;
var Deno = global$y.Deno;
var versions = process$3 && process$3.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$8 = fails$c;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$8(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$x = global$C;
var getBuiltIn$5 = getBuiltIn$7;
var isCallable$f = isCallable$i;
var isPrototypeOf$3 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var Object$4 = global$x.Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$5('Symbol');
  return isCallable$f($Symbol) && isPrototypeOf$3($Symbol.prototype, Object$4(it));
};

var global$w = global$C;

var String$5 = global$w.String;

var tryToString$4 = function (argument) {
  try {
    return String$5(argument);
  } catch (error) {
    return 'Object';
  }
};

var global$v = global$C;
var isCallable$e = isCallable$i;
var tryToString$3 = tryToString$4;

var TypeError$c = global$v.TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$5 = function (argument) {
  if (isCallable$e(argument)) return argument;
  throw TypeError$c(tryToString$3(argument) + ' is not a function');
};

var aCallable$4 = aCallable$5;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$4(func);
};

var global$u = global$C;
var call$9 = functionCall;
var isCallable$d = isCallable$i;
var isObject$6 = isObject$7;

var TypeError$b = global$u.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$d(fn = input.toString) && !isObject$6(val = call$9(fn, input))) return val;
  if (isCallable$d(fn = input.valueOf) && !isObject$6(val = call$9(fn, input))) return val;
  if (pref !== 'string' && isCallable$d(fn = input.toString) && !isObject$6(val = call$9(fn, input))) return val;
  throw TypeError$b("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$t = global$C;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$4 = Object.defineProperty;

var setGlobal$3 = function (key, value) {
  try {
    defineProperty$4(global$t, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$t[key] = value;
  } return value;
};

var global$s = global$C;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$4 = global$s[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$4;

var store$3 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$3[key] || (store$3[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.20.3',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.20.3/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var global$r = global$C;
var requireObjectCoercible = requireObjectCoercible$2;

var Object$3 = global$r.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$3 = function (argument) {
  return Object$3(requireObjectCoercible(argument));
};

var uncurryThis$b = functionUncurryThis;
var toObject$2 = toObject$3;

var hasOwnProperty = uncurryThis$b({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$2(it), key);
};

var uncurryThis$a = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$2 = uncurryThis$a(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$2(++id + postfix, 36);
};

var global$q = global$C;
var shared$2 = shared$3.exports;
var hasOwn$a = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$q.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$e = function (name) {
  if (!hasOwn$a(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL$1 || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL$1 && hasOwn$a(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var global$p = global$C;
var call$8 = functionCall;
var isObject$5 = isObject$7;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$d = wellKnownSymbol$e;

var TypeError$a = global$p.TypeError;
var TO_PRIMITIVE = wellKnownSymbol$d('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$5(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$8(exoticToPrim, input, pref);
    if (!isObject$5(result) || isSymbol$1(result)) return result;
    throw TypeError$a("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$o = global$C;
var isObject$4 = isObject$7;

var document$3 = global$o.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$4(document$3) && isObject$4(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$a = descriptors;
var fails$7 = fails$c;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$a && !fails$7(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$9 = descriptors;
var call$7 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$9 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$9 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$9(O, P)) return createPropertyDescriptor$2(!call$7(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$8 = descriptors;
var fails$6 = fails$c;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$8 && fails$6(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var global$n = global$C;
var isObject$3 = isObject$7;

var String$4 = global$n.String;
var TypeError$9 = global$n.TypeError;

// `Assert: Type(argument) is Object`
var anObject$a = function (argument) {
  if (isObject$3(argument)) return argument;
  throw TypeError$9(String$4(argument) + ' is not an object');
};

var global$m = global$C;
var DESCRIPTORS$7 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$9 = anObject$a;
var toPropertyKey = toPropertyKey$2;

var TypeError$8 = global$m.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$7 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$9(O);
  P = toPropertyKey(P);
  anObject$9(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$9(O);
  P = toPropertyKey(P);
  anObject$9(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError$8('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$6 = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$5 = DESCRIPTORS$6 ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$5 = {exports: {}};

var uncurryThis$9 = functionUncurryThis;
var isCallable$c = isCallable$i;
var store$2 = sharedStore;

var functionToString = uncurryThis$9(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$c(store$2.inspectSource)) {
  store$2.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$4 = store$2.inspectSource;

var global$l = global$C;
var isCallable$b = isCallable$i;
var inspectSource$3 = inspectSource$4;

var WeakMap$1 = global$l.WeakMap;

var nativeWeakMap = isCallable$b(WeakMap$1) && /native code/.test(inspectSource$3(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$k = global$C;
var uncurryThis$8 = functionUncurryThis;
var isObject$2 = isObject$7;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$8 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$7 = global$k.TypeError;
var WeakMap = global$k.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$7('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store$1 = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis$8(store$1.get);
  var wmhas = uncurryThis$8(store$1.has);
  var wmset = uncurryThis$8(store$1.set);
  set$1 = function (it, metadata) {
    if (wmhas(store$1, it)) throw new TypeError$7(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store$1, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store$1, it) || {};
  };
  has = function (it) {
    return wmhas(store$1, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$8(it, STATE)) throw new TypeError$7(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$8(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$8(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var DESCRIPTORS$5 = descriptors;
var hasOwn$7 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$7(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$5 || (DESCRIPTORS$5 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var global$j = global$C;
var isCallable$a = isCallable$i;
var hasOwn$6 = hasOwnProperty_1;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var setGlobal$1 = setGlobal$3;
var inspectSource$2 = inspectSource$4;
var InternalStateModule$2 = internalState;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;

var getInternalState$2 = InternalStateModule$2.get;
var enforceInternalState = InternalStateModule$2.enforce;
var TEMPLATE = String(String).split('String');

(redefine$5.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable$a(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn$6(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
      createNonEnumerableProperty$3(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global$j) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$3(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable$a(this) && getInternalState$2(this).source || inspectSource$2(this);
});

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$2 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$2;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$1(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var uncurryThis$7 = functionUncurryThis;
var hasOwn$5 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push = uncurryThis$7([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$5(hiddenKeys$2, key) && hasOwn$5(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$5(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$4 = getBuiltIn$7;
var uncurryThis$6 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$8 = anObject$a;

var concat$1 = uncurryThis$6([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$4('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$8(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$4 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$3 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$3.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$4(target, key) && !(exceptions && hasOwn$4(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$5 = fails$c;
var isCallable$9 = isCallable$i;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$9(detection) ? fails$5(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$i = global$C;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var redefine$4 = redefine$5.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$1 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$i;
  } else if (STATIC) {
    target = global$i[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$i[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$2(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$4(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$4 = descriptors;
var uncurryThis$5 = functionUncurryThis;
var call$6 = functionCall;
var fails$4 = fails$c;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$1 = toObject$3;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$3 = Object.defineProperty;
var concat = uncurryThis$5([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$4(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$4 && $assign({ b: 1 }, $assign(defineProperty$3({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$3(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$1(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$4 || call$6(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$3 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$3({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

const machineCloudClientTypes = {
  railsToken: "railsToken",
  masterMachineSerialNumber: "masterMachineSerialNumber"
};
const machineCloudClientApi = createApi({
  reducerPath: "machineCloudClientApi",
  baseQuery: (args, WebApi, extraOptions) => {
    const rawBaseQuery = fetchBaseQuery({
      baseUrl: environment.machineCloudClientUrl
    });
    return rawBaseQuery(args, WebApi, extraOptions);
  },
  tagTypes: Object.values(machineCloudClientTypes),
  endpoints: () => ({})
});

const initialState = {
  isConnectionInitiated: false,
  isRemoteSupportConnected: false,
  isRemoteSupportVisible: false,
  participantAuthToken: null,
  meetingRoomName: null,
  meetingId: null,
  isMeetingEnded: false,
  callDuration: null,
  isInWaitingRoom: false,
  isScreenSharing: false,
  isServerError: false,
  eStopStatus: EstopStatus.Unkonwn
};
const remoteSupportMeetingSlice = createSlice({
  name: "remoteSupportMeeting",
  initialState,
  reducers: {
    setConnectionInitiated: (state, action) => {
      state.isConnectionInitiated = action.payload;
    },
    setRemoteSupportVisible: (state, action) => {
      state.isRemoteSupportVisible = action.payload;
    },
    endRemoteSupportMeeting: (state, action) => {
      state.isRemoteSupportConnected = false;
      state.isRemoteSupportVisible = false;
      state.isMeetingEnded = true;
      state.callDuration = action.payload;
      state.meetingRoomName = null;
      state.participantAuthToken = null;
      state.isInWaitingRoom = false;
      state.isScreenSharing = false;
    },
    setIsScreenSharing: (state, action) => {
      state.isScreenSharing = action.payload;
    },
    setDyteMeetingDetails: (state, action) => {
      state.participantAuthToken = action.payload.authToken;
      state.meetingRoomName = action.payload.meetingRoomName;
      state.meetingId = action.payload.meetingId;
    },
    connectionInitialized: state => {
      state.isConnectionInitiated = false;
      state.isRemoteSupportConnected = true;
      state.isRemoteSupportVisible = true;
      state.isInWaitingRoom = true;
    },
    setInWaitingRoom: (state, action) => {
      state.isInWaitingRoom = action.payload;
    },
    setIsServerError: state => {
      state.isServerError = true;
    },
    resetRemoteSupport: () => {
      return initialState;
    },
    setEStopStatus: (state, action) => {
      state.eStopStatus = action.payload;
    }
  }
});

const rootReducer = combineReducers({
  snackbarReducer: snackbarSlice.reducer,
  dialogsReducer: dialogsSlice.reducer,
  remoteSupportMeetingReducer: remoteSupportMeetingSlice.reducer,
  [ecommerceApi.reducerPath]: ecommerceApi.reducer,
  [machineCloudApi.reducerPath]: machineCloudApi.reducer,
  [machineCloudClientApi.reducerPath]: machineCloudClientApi.reducer
});
const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: false
  }).concat(errorMiddleware()).concat(ecommerceApi.middleware).concat(machineCloudApi.middleware).concat(machineCloudClientApi.middleware)
});
setupListeners(store.dispatch);
const useAppDispatch = useDispatch;
const useAppSelector = useSelector;

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
const RemoteSupportProvider = props => {
  environment.railsUrl = props.railsUrl;
  environment.machineCloudClientUrl = props.machineCloudClientUrl;
  environment.machineCloudApiUrl = props.machineCloudApiUrl;
  environment.isTestingRemoteSupport = props.isTestingRemoteSupport;
  return jsx(Provider, Object.assign({
    store: store
  }, {
    children: jsxs(ThemeProvider, Object.assign({
      theme: customTheme
    }, {
      children: [jsx(SnackbarListener, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        fontSize: "18px",
        useAppDispatch: useAppDispatch,
        useAppSelector: useAppSelector
      }), jsx(DialogListener, {
        useAppDispatch: useAppDispatch,
        useAppSelector: useAppSelector,
        shouldDisplayDialogs: true
      }), props.children]
    }))
  }));
};

const baseColor = "#1C344F";
const alternativeColor = "white";
const RemoteSupportIcon = props => {
  const scale = props.scale ? props.scale : 1;
  const width = 131 * scale;
  const height = 141 * scale;
  const color = props.isColorFlipped ? alternativeColor : baseColor;
  return jsxs("svg", Object.assign({
    width: width,
    height: height,
    viewBox: "0 0 131 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      d: "M18.8212 106.011C7.43082 106.011 2.95755 98.3452 2.05841 94.2437C2.0162 94.0512 2 93.8567 2 93.6596V66.3323C2 65.6982 2.1877 65.0783 2.53944 64.5507L5.53293 60.0604C5.79118 59.673 5.95857 59.2477 6.03604 58.7886C9.30486 39.419 25.816 2 67.0419 2C108.202 2 122.724 39.2987 124.99 58.695C125.05 59.2143 125.227 59.6998 125.517 60.1348L128.461 64.5507C128.812 65.0783 129 65.6982 129 66.3323V93.6596C129 93.8567 128.985 94.0513 128.938 94.2427C127.934 98.3438 121.248 106.011 113.581 106.011",
      stroke: color,
      strokeWidth: "3.93"
    }), jsx("path", {
      d: "M18.5408 56.669C22.0919 42.9316 37.0441 15.457 66.2008 15.457C95.3575 15.457 109.188 42.9316 114.141 56.669",
      stroke: color,
      strokeWidth: "3.93"
    }), jsx("rect", {
      x: "94.5167",
      y: "47.978",
      width: "22.4283",
      height: "63.9205",
      rx: "8.56512",
      fill: color
    }), jsx("rect", {
      x: "94.5167",
      y: "47.978",
      width: "22.4283",
      height: "63.9205",
      rx: "8.56512",
      fill: color
    }), jsx("rect", {
      x: "15.4569",
      y: "47.978",
      width: "22.4283",
      height: "63.9205",
      rx: "8.56512",
      fill: color
    }), jsx("rect", {
      x: "15.4569",
      y: "47.978",
      width: "22.4283",
      height: "63.9205",
      rx: "8.56512",
      fill: color
    }), jsx("path", {
      d: "M114.702 106.011C114.328 111.431 108.029 124.682 85.8254 134.326",
      stroke: color,
      strokeWidth: "3.93"
    }), jsx("rect", {
      x: "61.4351",
      y: "124.795",
      width: "28.0353",
      height: "15.6998",
      rx: "7.84989",
      fill: "#1AC876"
    })]
  }));
};

const NoOneAvailableDialog = props => {
  const classes = useStyles$9();
  const dispatch = useAppDispatch();
  const closeThisDialog = () => {
    dispatch(dialogsSlice.actions.remove({
      name: NoOneAvailableDialog.name
    }));
    props.onDialogueClose();
  };
  return jsxs(Box, Object.assign({
    className: classes.noOneAvailableDialog
  }, {
    children: [jsx(RemoteSupportIcon, {}), jsx(DialogTitle, {
      children: jsx(Typography, Object.assign({
        variant: "h1",
        className: classes.messageTitle
      }, {
        children: "Continue Waiting?"
      }))
    }), jsx(DialogContent, {
      children: jsxs(Box, Object.assign({
        className: classes.messageBody
      }, {
        children: [jsx(Typography, Object.assign({
          variant: "h4"
        }, {
          children: "We apologize for the longer than expected wait time. Would you like to remain in the call?"
        })), jsxs(Typography, Object.assign({
          variant: "h4"
        }, {
          children: ["If not, please contact Vention at ", jsx("b", {
            children: "integrationsupport@vention.cc"
          }), " or ", jsx("b", {
            children: "1-800-940-3617"
          })]
        }))]
      }))
    }), jsx(DialogActions, Object.assign({
      className: classes.buttonsContainer
    }, {
      children: jsxs(Box, Object.assign({
        className: classes.buttonsContainer
      }, {
        children: [jsx(Button, Object.assign({
          size: "medium",
          color: "primary",
          variant: "contained",
          onClick: () => closeThisDialog()
        }, {
          children: "Stay In Waiting Room"
        })), jsx(Button, Object.assign({
          size: "medium",
          onClick: props.onCancelClick,
          className: classes.cancelCallRequestButton
        }, {
          children: "Cancel Call Request"
        }))]
      }))
    }))]
  }));
};
const useStyles$9 = makeStyles(theme => ({
  noOneAvailableDialog: {
    padding: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2.5),
    backgroundColor: "white",
    borderRadius: 3,
    zIndex: 400
  },
  messageTitle: {
    fontWeight: "bold"
  },
  messageBody: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    color: theme.palette.primary.main
  },
  buttonsContainer: {
    display: "grid",
    gap: theme.spacing(3)
  },
  cancelCallRequestButton: {
    backgroundColor: theme.palette.error.main,
    paddingRight: theme.spacing(8),
    paddingLeft: theme.spacing(8),
    color: theme.palette.common.white,
    "&:hover": {
      background: darken(theme.palette.error.main, 0.1)
    }
  }
}));

var objectDefineProperties = {};

var DESCRIPTORS$3 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$2 = objectDefineProperty;
var anObject$7 = anObject$a;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$3 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$7(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$3 = getBuiltIn$7;

var html$2 = getBuiltIn$3('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$6 = anObject$a;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$6(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$c = wellKnownSymbol$e;
var create$1 = objectCreate;
var definePropertyModule$1 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$c('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  definePropertyModule$1.f(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$3 = fails$c;

var correctPrototypeGetter = !fails$3(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var global$h = global$C;
var hasOwn$3 = hasOwnProperty_1;
var isCallable$8 = isCallable$i;
var toObject = toObject$3;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var Object$2 = global$h.Object;
var ObjectPrototype = Object$2.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object$2.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn$3(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$8(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object$2 ? ObjectPrototype : null;
};

var fails$2 = fails$c;
var isCallable$7 = isCallable$i;
var getPrototypeOf$1 = objectGetPrototypeOf;
var redefine$3 = redefine$5.exports;
var wellKnownSymbol$b = wellKnownSymbol$e;

var ITERATOR$5 = wellKnownSymbol$b('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$2(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$5].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$7(IteratorPrototype$2[ITERATOR$5])) {
  redefine$3(IteratorPrototype$2, ITERATOR$5, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$2 = hasOwnProperty_1;
var wellKnownSymbol$a = wellKnownSymbol$e;

var TO_STRING_TAG$3 = wellKnownSymbol$a('toStringTag');

var setToStringTag$3 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$2(target, TO_STRING_TAG$3)) {
    defineProperty$2(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$2 = setToStringTag$3;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var global$g = global$C;
var isCallable$6 = isCallable$i;

var String$3 = global$g.String;
var TypeError$6 = global$g.TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$6(argument)) return argument;
  throw TypeError$6("Can't set " + String$3(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$4 = functionUncurryThis;
var anObject$5 = anObject$a;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$4(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$5(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$2 = _export;
var call$5 = functionCall;
var FunctionName = functionName;
var isCallable$5 = isCallable$i;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var redefine$2 = redefine$5.exports;
var wellKnownSymbol$9 = wellKnownSymbol$e;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$9('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$5(CurrentIteratorPrototype[ITERATOR$4])) {
          redefine$2(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$5(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$2(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$2({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    redefine$2(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables = addToUnscopables$1;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = defineIterator$1;
var DESCRIPTORS$2 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$2 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$f = global$C;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$5;
var wellKnownSymbol$8 = wellKnownSymbol$e;

var ITERATOR$3 = wellKnownSymbol$8('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$8('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$f[COLLECTION_NAME] && global$f[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var global$e = global$C;

var nativePromiseConstructor = global$e.Promise;

var redefine$1 = redefine$5.exports;

var redefineAll$1 = function (target, src, options) {
  for (var key in src) redefine$1(target, key, src[key], options);
  return target;
};

var getBuiltIn$2 = getBuiltIn$7;
var definePropertyModule = objectDefineProperty;
var wellKnownSymbol$7 = wellKnownSymbol$e;
var DESCRIPTORS$1 = descriptors;

var SPECIES$2 = wellKnownSymbol$7('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$2(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS$1 && Constructor && !Constructor[SPECIES$2]) {
    defineProperty(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var global$d = global$C;
var isPrototypeOf$2 = objectIsPrototypeOf;

var TypeError$5 = global$d.TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf$2(Prototype, it)) return it;
  throw TypeError$5('Incorrect invocation');
};

var uncurryThis$3 = functionUncurryThis;
var aCallable$3 = aCallable$5;
var NATIVE_BIND$1 = functionBindNative;

var bind$4 = uncurryThis$3(uncurryThis$3.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$3(fn);
  return that === undefined ? fn : NATIVE_BIND$1 ? bind$4(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var wellKnownSymbol$6 = wellKnownSymbol$e;
var Iterators$1 = iterators;

var ITERATOR$2 = wellKnownSymbol$6('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$2] === it);
};

var wellKnownSymbol$5 = wellKnownSymbol$e;

var TO_STRING_TAG$1 = wellKnownSymbol$5('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var global$c = global$C;
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$4 = isCallable$i;
var classofRaw = classofRaw$1;
var wellKnownSymbol$4 = wellKnownSymbol$e;

var TO_STRING_TAG = wellKnownSymbol$4('toStringTag');
var Object$1 = global$c.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$4 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object$1(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$4(O.callee) ? 'Arguments' : result;
};

var classof$3 = classof$4;
var getMethod$1 = getMethod$3;
var Iterators = iterators;
var wellKnownSymbol$3 = wellKnownSymbol$e;

var ITERATOR$1 = wellKnownSymbol$3('iterator');

var getIteratorMethod$2 = function (it) {
  if (it != undefined) return getMethod$1(it, ITERATOR$1)
    || getMethod$1(it, '@@iterator')
    || Iterators[classof$3(it)];
};

var global$b = global$C;
var call$4 = functionCall;
var aCallable$2 = aCallable$5;
var anObject$4 = anObject$a;
var tryToString$2 = tryToString$4;
var getIteratorMethod$1 = getIteratorMethod$2;

var TypeError$4 = global$b.TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$2(iteratorMethod)) return anObject$4(call$4(iteratorMethod, argument));
  throw TypeError$4(tryToString$2(argument) + ' is not iterable');
};

var call$3 = functionCall;
var anObject$3 = anObject$a;
var getMethod = getMethod$3;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$3(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$3(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$3(innerResult);
  return value;
};

var global$a = global$C;
var bind$3 = functionBindContext;
var call$2 = functionCall;
var anObject$2 = anObject$a;
var tryToString$1 = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike = lengthOfArrayLike$2;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose = iteratorClose$1;

var TypeError$3 = global$a.TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$1 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$3(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$2(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError$3(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$1(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = call$2(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$1(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$2 = wellKnownSymbol$e;

var ITERATOR = wellKnownSymbol$2('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var uncurryThis$2 = functionUncurryThis;
var fails$1 = fails$c;
var isCallable$3 = isCallable$i;
var classof$2 = classof$4;
var getBuiltIn$1 = getBuiltIn$7;
var inspectSource$1 = inspectSource$4;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$1('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$2(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$3(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$3(argument)) return false;
  switch (classof$2(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$1(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var global$9 = global$C;
var isConstructor = isConstructor$1;
var tryToString = tryToString$4;

var TypeError$2 = global$9.TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError$2(tryToString(argument) + ' is not a constructor');
};

var anObject$1 = anObject$a;
var aConstructor = aConstructor$1;
var wellKnownSymbol$1 = wellKnownSymbol$e;

var SPECIES$1 = wellKnownSymbol$1('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$1(O).constructor;
  var S;
  return C === undefined || (S = anObject$1(C)[SPECIES$1]) == undefined ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$1 = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call$1.bind(apply$1) : function () {
  return call$1.apply(apply$1, arguments);
});

var uncurryThis$1 = functionUncurryThis;

var arraySlice$1 = uncurryThis$1([].slice);

var userAgent$2 = engineUserAgent;

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var classof$1 = classofRaw$1;
var global$8 = global$C;

var engineIsNode = classof$1(global$8.process) == 'process';

var global$7 = global$C;
var apply = functionApply;
var bind$2 = functionBindContext;
var isCallable$2 = isCallable$i;
var hasOwn$1 = hasOwnProperty_1;
var fails = fails$c;
var html = html$2;
var arraySlice = arraySlice$1;
var createElement = documentCreateElement$2;
var IS_IOS$1 = engineIsIos;
var IS_NODE$2 = engineIsNode;

var set = global$7.setImmediate;
var clear = global$7.clearImmediate;
var process$2 = global$7.process;
var Dispatch = global$7.Dispatch;
var Function$1 = global$7.Function;
var MessageChannel = global$7.MessageChannel;
var String$2 = global$7.String;
var counter = 0;
var queue$1 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global$7.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn$1(queue$1, id)) {
    var fn = queue$1[id];
    delete queue$1[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$7.postMessage(String$2(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = arraySlice(arguments, 1);
    queue$1[++counter] = function () {
      apply(isCallable$2(fn) ? fn : Function$1(fn), undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$1[id];
  };
  // Node.js 0.8-
  if (IS_NODE$2) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$2(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$7.addEventListener &&
    isCallable$2(global$7.postMessage) &&
    !global$7.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global$7.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var userAgent$1 = engineUserAgent;
var global$6 = global$C;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && global$6.Pebble !== undefined;

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$5 = global$C;
var bind$1 = functionBindContext;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$1 = engineIsNode;

var MutationObserver = global$5.MutationObserver || global$5.WebKitMutationObserver;
var document$2 = global$5.document;
var process$1 = global$5.process;
var Promise$1 = global$5.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$5, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$1 && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$1 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$1(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$1) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind$1(macrotask, global$5);
    notify$1 = function () {
      macrotask(flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var newPromiseCapability$2 = {};

var aCallable$1 = aCallable$5;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$1(resolve);
  this.reject = aCallable$1(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var anObject = anObject$a;
var isObject$1 = isObject$7;
var newPromiseCapability$1 = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject(C);
  if (isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var global$4 = global$C;

var hostReportErrors$1 = function (a, b) {
  var console = global$4.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$1 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var Queue$1 = function () {
  this.head = null;
  this.tail = null;
};

Queue$1.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

var queue = Queue$1;

var engineIsBrowser = typeof window == 'object';

var $$1 = _export;
var global$3 = global$C;
var getBuiltIn = getBuiltIn$7;
var call = functionCall;
var NativePromise = nativePromiseConstructor;
var redefine = redefine$5.exports;
var redefineAll = redefineAll$1;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$3;
var setSpecies = setSpecies$1;
var aCallable = aCallable$5;
var isCallable$1 = isCallable$i;
var isObject = isObject$7;
var anInstance = anInstance$1;
var inspectSource = inspectSource$4;
var iterate = iterate$1;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask$1;
var promiseResolve = promiseResolve$1;
var hostReportErrors = hostReportErrors$1;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$1;
var Queue = queue;
var InternalStateModule = internalState;
var isForced = isForced_1;
var wellKnownSymbol = wellKnownSymbol$e;
var IS_BROWSER = engineIsBrowser;
var IS_NODE = engineIsNode;
var V8_VERSION = engineV8Version;

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';

var getInternalState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromisePrototype = NativePromisePrototype;
var TypeError$1 = global$3.TypeError;
var document$1 = global$3.document;
var process = global$3.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$3.dispatchEvent);
var NATIVE_REJECTION_EVENT = isCallable$1(global$3.PromiseRejectionEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable$1(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$3.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global$3['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global$3, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global$3, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromisePrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    // eslint-disable-next-line unicorn/no-thenable -- safe
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      state.parent = true;
      reaction.ok = isCallable$1(onFulfilled) ? onFulfilled : true;
      reaction.fail = isCallable$1(onRejected) && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      if (state.state == PENDING) state.reactions.add(reaction);
      else microtask(function () {
        callReaction(reaction, state);
      });
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$1(NativePromise) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine(NativePromisePrototype, 'catch', PromisePrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$$1({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$$1({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});

$$1({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

$$1({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

const machineCloudPendantEndpoints = machineCloudApi.injectEndpoints({
  endpoints: build => ({
    createMeetingAndAddParticipantToMeeting: build.mutation({
      query: params => ({
        url: `/api/remote-support/meeting-and-add-participant`,
        method: "POST",
        body: {
          serialNumber: params.createMeetingAndAddParticipantToMeetingRequest.serialNumber,
          isTestingRemoteSupport: params.createMeetingAndAddParticipantToMeetingRequest.isTestingRemoteSupport
        },
        headers: {
          Authorization: params.token
        }
      }),
      async onQueryStarted(_, {
        dispatch,
        queryFulfilled
      }) {
        try {
          const {
            data
          } = await queryFulfilled;
          dispatch(remoteSupportMeetingSlice.actions.setDyteMeetingDetails(data));
        } catch (error) {
          console.error(error);
          dispatch(remoteSupportMeetingSlice.actions.setIsServerError());
        }
      }
    }),
    askForBusinessHours: build.query({
      query: params => ({
        url: `/api/remote-support/business-hours?service-site=${params.serviceSite}`,
        method: "GET",
        headers: {
          Authorization: params.token
        }
      })
    }),
    updateZendeskTicketLeaveWaitingRoom: build.mutation({
      query: params => ({
        url: `/api/remote-support/update-zendesk-ticket-leave-waiting-room`,
        method: "PUT",
        body: params.updateInfo,
        headers: {
          Authorization: params.token
        }
      })
    }),
    updateZendeskTicketMeetingEnd: build.mutation({
      query: params => ({
        url: `/api/remote-support/update-zendesk-ticket-meeting-end`,
        method: "PUT",
        body: params.updateInfo,
        headers: {
          Authorization: params.token
        }
      })
    })
  })
});
const {
  useCreateMeetingAndAddParticipantToMeetingMutation,
  useAskForBusinessHoursQuery,
  useUpdateZendeskTicketLeaveWaitingRoomMutation,
  useUpdateZendeskTicketMeetingEndMutation
} = machineCloudPendantEndpoints;

const remoteSupportApiEndpoints = machineCloudClientApi.injectEndpoints({
  endpoints: build => ({
    getRailsToken: build.query({
      query: () => ({
        url: `/api/remote-support/rails-token`
      }),
      providesTags: [machineCloudClientTypes.railsToken]
    }),
    getMasterMachineSerialNumber: build.query({
      query: () => ({
        url: `/api/remote-support/master-machine-serial-number`
      }),
      providesTags: [machineCloudClientTypes.masterMachineSerialNumber]
    }),
    checkMachineCloudConnected: build.query({
      query: () => ({
        url: `/api/remote-support/is-machine-cloud-connected`,
        method: "GET"
      })
    })
  })
});
const {
  useCheckMachineCloudConnectedQuery,
  useGetRailsTokenQuery,
  useGetMasterMachineSerialNumberQuery
} = remoteSupportApiEndpoints;

// Seems to be the only way to get DyteClient as a type
const useDyte = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [dyteClient, initClient] = useDyteClient();
  const [createMeetingAndAddParticipantToMeeting, {
    isLoading
  }] = useCreateMeetingAndAddParticipantToMeetingMutation();
  const [updateZendeskTicketLeaveWaitingRoom] = useUpdateZendeskTicketLeaveWaitingRoomMutation();
  const remoteSupportMeetingState = useAppSelector(state => state.remoteSupportMeetingReducer);
  const waitStartTime = useRef();
  const meetingStartTime = useRef();
  const {
    data: railsTokenData
  } = remoteSupportApiEndpoints.endpoints.getRailsToken.useQueryState();
  const {
    data: serialNumberData
  } = remoteSupportApiEndpoints.endpoints.getMasterMachineSerialNumber.useQueryState();
  useEffect(function startDyteMeeting() {
    if (remoteSupportMeetingState.isConnectionInitiated) {
      createMeetingAndAddParticipantToMeeting({
        createMeetingAndAddParticipantToMeetingRequest: {
          serialNumber: serialNumberData.serialNumber,
          isTestingRemoteSupport: environment.isTestingRemoteSupport
        },
        token: railsTokenData.token
      });
    }
  }, [remoteSupportMeetingState.isConnectionInitiated]);
  useEffect(function startDyteClientUponReceiveMeetingRoomAndAuthToken() {
    if (!isLoading && remoteSupportMeetingState.isConnectionInitiated && !remoteSupportMeetingState.isRemoteSupportConnected && remoteSupportMeetingState.participantAuthToken && remoteSupportMeetingState.meetingRoomName) {
      initClient({
        authToken: remoteSupportMeetingState.participantAuthToken,
        roomName: remoteSupportMeetingState.meetingRoomName,
        defaults: {
          audio: true,
          video: true
        }
      });
    }
  }, [isLoading, remoteSupportMeetingState.isConnectionInitiated, remoteSupportMeetingState.isRemoteSupportConnected, remoteSupportMeetingState.participantAuthToken, remoteSupportMeetingState.meetingRoomName]);
  useEffect(function calculateWaitTime() {
    if (remoteSupportMeetingState.isInWaitingRoom) {
      waitStartTime.current = dayjs();
    } else if (railsTokenData && remoteSupportMeetingState.meetingId) {
      const waitTime = dayjs.duration(dayjs().diff(waitStartTime.current)).format("HH:mm:ss");
      updateZendeskTicketLeaveWaitingRoom({
        updateInfo: {
          meetingId: remoteSupportMeetingState.meetingId,
          waitTime: waitTime,
          status: "open"
        },
        token: railsTokenData.token
      });
    }
  }, [remoteSupportMeetingState.isInWaitingRoom]);
  useEffect(function monitorDyteClient() {
    if (dyteClient) {
      dispatch(remoteSupportMeetingSlice.actions.connectionInitialized());
      meetingStartTime.current = undefined;
      dyteClient.meta.on("disconnected", () => {
        console.log("Dyte client disconnected");
        dyteClient.leaveRoom();
        const duration = dayjs.duration(dayjs().diff(meetingStartTime.current)).format("HH:mm:ss");
        dispatch(remoteSupportMeetingSlice.actions.endRemoteSupportMeeting(duration));
        navigate("/remote-support");
      });
      dyteClient.meta.on("poorConnection", () => {
        console.log("The local user has poor network connection.");
      });
      dyteClient.meta.on("connectionError", ({
        reason
      }) => {
        console.log("Could not connect to the room.", reason);
      });
      dyteClient.self.on("roomJoined", () => {
        dispatch(remoteSupportMeetingSlice.actions.setInWaitingRoom(false));
        meetingStartTime.current = dayjs();
        console.log("User has joined the meeting and ready to produce and consume media");
      });
      dyteClient.self.on("screenShareUpdate", event => {
        dispatch(remoteSupportMeetingSlice.actions.setIsScreenSharing(event.screenShareEnabled));
      });
    }
  }, [dyteClient]);
  return {
    dyteClient
  };
};

const CancelMeetingConfirmationDialog = props => {
  const classes = useStyles$8();
  const dispatch = useAppDispatch();
  const closeThisDialog = () => dispatch(dialogsSlice.actions.remove({
    name: CancelMeetingConfirmationDialog.name
  }));
  return jsx(ConfirmationDialog, Object.assign({
    closeDialog: closeThisDialog,
    confirmAction: props.onCancelClick,
    isDestructiveConfirmAction: true,
    confirmActionText: "Cancel Call Request",
    cancelActionText: "Stay In Waiting Room",
    useAppDispatch: useAppDispatch
  }, {
    children: jsxs("div", Object.assign({
      className: classes.content
    }, {
      children: [jsx(Typography, Object.assign({
        variant: "h1"
      }, {
        children: "Are you sure?"
      })), jsx(Typography, {
        children: "We are trying to match you with a Vention Expert as soon as possible."
      })]
    }))
  }));
};
const useStyles$8 = makeStyles(theme => ({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    textAlign: "center"
  }
}));

const FlipCameraIcon = () => {
  return `<svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1440_897)">
        <path
          d="M10.3761 6.01993C10.3761 7.30797 9.32821 8.35586 8.04017 8.35586H4.51624L5.51195 9.35156C5.58036 9.41998 5.58036 9.5309 5.51195 9.59933L5.42937 9.68191C5.36096 9.75032 5.25003 9.75032 5.1816 9.68191L3.74584 8.24614C3.67743 8.17773 3.67743 8.0668 3.74584 7.99837L5.1816 6.56261C5.25002 6.4942 5.36094 6.4942 5.42937 6.56261L5.51195 6.64518C5.58036 6.7136 5.58036 6.82453 5.51195 6.89295L4.51624 7.88867H8.04017C9.07059 7.88867 9.90891 7.05035 9.90891 6.01993C9.90891 5.60304 9.77163 5.21765 9.53997 4.90645C9.48789 4.83649 9.49445 4.73911 9.55611 4.67744L9.6394 4.59415C9.71474 4.51882 9.8391 4.52777 9.90341 4.61271C10.2 5.00435 10.3761 5.49194 10.3761 6.01993ZM3.73725 7.13341C3.50559 6.8222 3.36831 6.43682 3.36831 6.01993C3.36831 4.98951 4.20663 4.15119 5.23705 4.15119H8.76098L7.76527 5.14689C7.69686 5.2153 7.69686 5.32623 7.76527 5.39466L7.84785 5.47723C7.91626 5.54565 8.02719 5.54565 8.09562 5.47723L9.53138 4.04147C9.5998 3.97306 9.5998 3.86213 9.53138 3.7937L8.09563 2.35795C8.02722 2.28954 7.91629 2.28954 7.84786 2.35795L7.76529 2.44053C7.69687 2.50894 7.69687 2.61987 7.76529 2.6883L8.76098 3.684H5.23705C3.94901 3.684 2.90112 4.73188 2.90112 6.01993C2.90112 6.54792 3.07727 7.0355 3.3738 7.42714C3.43811 7.51208 3.56247 7.52104 3.6378 7.44569L3.72109 7.3624C3.78278 7.30073 3.78933 7.20337 3.73725 7.13341Z"
          fill="white"
        />
      </g>
      <rect x="1.05857" y="0.440039" width="11.16" height="11.16" rx="2.6" stroke="white" strokeWidth="0.8" />
      <path d="M12.2448 3.4039L16.356 1.53516V10.5051L12.2448 8.26263" stroke="white" strokeWidth="0.8" />
      <defs>
        <clipPath id="clip0_1440_897">
          <rect width="7.47498" height="7.47498" fill="white" transform="translate(2.90112 2.28223)" />
        </clipPath>
      </defs>
    </svg>`;
};

const RemoteSupportMeetingPage = () => {
  const classes = useStyles$7();
  const {
    meeting
  } = useDyteMeeting();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const remoteSupportMeetingState = useAppSelector(state => state.remoteSupportMeetingReducer);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [dyteChatToggleElement, setDyteChatToggleElement] = useState();
  const [dyteMeetingControlBarElement, setDyteMeetingControlBarElement] = useState();
  const lookingForDyteChatToggleAndControlBarInterval = useRef();
  const lookingForDyteChatToggleAndControlBarAttempts = useRef(0);
  const lookForDyteChatToggleAndControlBarMaxAttempts = 25;
  const [dyteChatInputElement, setDyteChatInputElement] = useState();
  const lookingForDyteChatInputInterval = useRef();
  const lookingForDyteChatInputAttempts = useRef(0);
  const lookingForDyteChatInputMaxAttempts = 25;
  /**
   * When setting the visibility of the entire Remote Support Meeting Overlay to "hidden", the Dyte Participant Tiles take about half
   * a second to stop being visible even after the rest of the meeting UI becomes hidden. By extracting
   * the specific Dyte Participant Tile elements themselves and manually setting their visibility to hidden,
   * they visually become hidden in about 200 ms, which is a significant improvement. Because of this, before trying to hide the entire meeting UI,
   * we first manually hide the tiles, wait 200ms, and then hide the rest of the ui. This way, they all become hidden at around the same time. If we are screen sharing, the same issue
   * exists with the screen share preview and the entire screen share view container, so the same is done with those elements.
   * @param visibility What you are setting the visibility property of the Dyte Participant Tile to; either "hidden" or "visible"
   */
  function setVisibilityOfDyteComponents(visibility) {
    var _a, _b, _c, _d, _e, _f, _g;
    const dyteGridShadowRoot = (_c = (_b = (_a = document.querySelector("dyte-meeting")) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("dyte-grid")) === null || _c === void 0 ? void 0 : _c.shadowRoot;
    // we need to get the dyte-simple-grid element, because it is the parent of the <dyte-participant-tile>s. If you are currently sharing your screen,
    // dyte-mixed-grid is the parent of dyte-simple-grid. If you are not screen sharing, dyte-mixed-grid is not present, and dyte-simple-grid is the direct child of dyte-grid.
    // In the case that we are not screensharing, both screenShareView and screenShareVideoStream would be set to undefined.
    const simpleGridParent = ((_d = dyteGridShadowRoot === null || dyteGridShadowRoot === void 0 ? void 0 : dyteGridShadowRoot.querySelector("dyte-mixed-grid")) === null || _d === void 0 ? void 0 : _d.shadowRoot) || dyteGridShadowRoot;
    const screenShareView = simpleGridParent === null || simpleGridParent === void 0 ? void 0 : simpleGridParent.querySelector("dyte-screenshare-view");
    const screenShareVideoStream = (_e = screenShareView === null || screenShareView === void 0 ? void 0 : screenShareView.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector("video");
    const participantTiles = (_g = (_f = simpleGridParent === null || simpleGridParent === void 0 ? void 0 : simpleGridParent.querySelector("dyte-simple-grid")) === null || _f === void 0 ? void 0 : _f.shadowRoot) === null || _g === void 0 ? void 0 : _g.querySelectorAll("dyte-participant-tile");
    if (screenShareView) {
      screenShareView.style.visibility = visibility;
      screenShareVideoStream.style.visibility = visibility;
    }
    participantTiles === null || participantTiles === void 0 ? void 0 : participantTiles.forEach(participantTile => {
      participantTile.style.visibility = visibility;
    });
  }
  const removeFlipCameraButton = () => {
    const flipCameraButtonContainer = dyteMeetingControlBarElement === null || dyteMeetingControlBarElement === void 0 ? void 0 : dyteMeetingControlBarElement.querySelector("#flip-camera-button");
    flipCameraButtonContainer === null || flipCameraButtonContainer === void 0 ? void 0 : flipCameraButtonContainer.removeEventListener("click", handleFlipCamera);
    flipCameraButtonContainer === null || flipCameraButtonContainer === void 0 ? void 0 : flipCameraButtonContainer.remove();
  };
  const handleNavigateBack = () => {
    setVisibilityOfDyteComponents("hidden");
    // As mentioned above, we need to wait 200 ms for the above function to take visual effect. We set a Timeout before hiding the rest of the UI so that
    // all components of the UI hide at the same time.
    setTimeout(() => {
      dispatch(remoteSupportMeetingSlice.actions.setRemoteSupportVisible(false));
      navigate(-1);
    }, 200);
  };
  const handleFlipCamera = async () => {
    const videoDevices = await meeting.self.getVideoDevices();
    const currentVideoDeviceId = meeting.self.getCurrentDevices().video.deviceId;
    const nextVideoDevice = videoDevices.find(videoDevice => videoDevice.deviceId !== currentVideoDeviceId);
    if (nextVideoDevice) {
      meeting.self.setDevice(nextVideoDevice);
    } else {
      dispatch(snackbarSlice.actions.display({
        message: "No other video devices found.",
        severity: "warning"
      }));
    }
  };
  useEffect(function checkFlipCameraButton() {
    const existingFlipCameraButton = dyteMeetingControlBarElement === null || dyteMeetingControlBarElement === void 0 ? void 0 : dyteMeetingControlBarElement.querySelector("#flip-camera-button");
    if (dyteMeetingControlBarElement && !existingFlipCameraButton) {
      const flipCameraButtonContainer = document.createElement("div");
      flipCameraButtonContainer.setAttribute("id", "flip-camera-button");
      flipCameraButtonContainer.addEventListener("click", handleFlipCamera);
      dyteMeetingControlBarElement.insertBefore(flipCameraButtonContainer, dyteMeetingControlBarElement.children[2]);
      const flipCameraButton = /*#__PURE__*/React.createElement(DyteControlbarButton, {
        label: "Flip Camera",
        icon: FlipCameraIcon(),
        size: "lg"
      });
      ReactDOM.render(flipCameraButton, flipCameraButtonContainer);
    }
    return () => {
      removeFlipCameraButton();
    };
  }, [dyteMeetingControlBarElement]);
  const attemptFindChatToggleAndControlBar = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const chatToggleButton = (_f = (_e = (_d = (_c = (_b = (_a = document.querySelector("dyte-meeting")) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("dyte-chat-toggle")) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("dyte-controlbar-button")) === null || _e === void 0 ? void 0 : _e.shadowRoot) === null || _f === void 0 ? void 0 : _f.querySelector("button");
    const dyteMeetingControlBar = (_h = (_g = document.querySelector("dyte-meeting")) === null || _g === void 0 ? void 0 : _g.shadowRoot) === null || _h === void 0 ? void 0 : _h.querySelector("#controlbar-center");
    if (chatToggleButton && dyteMeetingControlBar) {
      setDyteChatToggleElement(chatToggleButton);
      setDyteMeetingControlBarElement(dyteMeetingControlBar);
    } else if (lookingForDyteChatToggleAndControlBarAttempts.current < lookForDyteChatToggleAndControlBarMaxAttempts) {
      lookingForDyteChatToggleAndControlBarAttempts.current += 1;
      return;
    }
    clearInterval(lookingForDyteChatToggleAndControlBarInterval.current);
  };
  const handleChatToggleClick = () => {
    setIsChatOpen(prevIsChatOpen => !prevIsChatOpen);
  };
  // We need to keep track of whether or not the meeting chat is open so we know when to look for the chat input box.
  useEffect(function lookForChatToggleAndControlBarOnInterval() {
    if (!remoteSupportMeetingState.isInWaitingRoom && remoteSupportMeetingState.isRemoteSupportConnected) {
      lookingForDyteChatToggleAndControlBarInterval.current = setInterval(attemptFindChatToggleAndControlBar, 20);
    }
    return () => {
      clearInterval(lookingForDyteChatToggleAndControlBarInterval.current);
      lookingForDyteChatToggleAndControlBarAttempts.current = 0;
    };
  }, [remoteSupportMeetingState.isInWaitingRoom]);
  // Once we find the toggle, we need to add a listener to it
  useEffect(function addListenerToDyteChatToggle() {
    dyteChatToggleElement === null || dyteChatToggleElement === void 0 ? void 0 : dyteChatToggleElement.addEventListener("click", handleChatToggleClick);
    return () => {
      dyteChatToggleElement === null || dyteChatToggleElement === void 0 ? void 0 : dyteChatToggleElement.removeEventListener("click", handleChatToggleClick);
    };
  }, [dyteChatToggleElement]);
  useEffect(() => {
    if (remoteSupportMeetingState.isRemoteSupportVisible) setVisibilityOfDyteComponents("visible");
  }, [remoteSupportMeetingState.isRemoteSupportVisible]);
  const emitFocusEventWithCorrectTarget = dyteChatInputFocusEvent => {
    if (dyteChatInputFocusEvent.isTrusted) {
      const customEvent = new CustomEvent(dyteChatInputFocusEvent.type, {
        bubbles: true,
        composed: true,
        cancelable: dyteChatInputFocusEvent.cancelable
      });
      Object.defineProperty(customEvent, "target", {
        value: dyteChatInputElement,
        writable: false
      });
      dyteChatInputElement.dispatchEvent(customEvent);
    }
  };
  const attemptFindDyteChat = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const dyteChatInput = (_h = (_g = (_f = (_e = (_d = (_c = (_b = (_a = document.querySelector("dyte-meeting")) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("dyte-sidebar")) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("dyte-chat")) === null || _e === void 0 ? void 0 : _e.shadowRoot) === null || _f === void 0 ? void 0 : _f.querySelector("dyte-chat-composer-ui")) === null || _g === void 0 ? void 0 : _g.shadowRoot) === null || _h === void 0 ? void 0 : _h.querySelector("textarea");
    if (dyteChatInput) {
      setDyteChatInputElement(dyteChatInput);
    } else if (lookingForDyteChatInputAttempts.current < lookingForDyteChatInputMaxAttempts) {
      lookingForDyteChatInputAttempts.current += 1;
      return;
    } else {
      // If the chat is not found, we can assume that chat is not actually open, meaning our state is innacurate. In this case, we update our state to reflect this.
      setIsChatOpen(false);
    }
    clearInterval(lookingForDyteChatInputInterval.current);
    lookingForDyteChatInputAttempts.current = 0;
  };
  /**
   * This is for the meeting chat.
   * Because the dyte meeting chat input is within multiple nested shadow roots, a simple document-level query will not find it; We need to explicitly traverse the
   * multiple shadow roots. If the meeting chat is opened, the below use effect will trigger a search for the input element on an interval.
   */
  useEffect(function lookForDyteChatOnInterval() {
    if (isChatOpen) {
      lookingForDyteChatInputInterval.current = setInterval(attemptFindDyteChat, 20);
    }
    return () => {
      clearInterval(lookingForDyteChatInputInterval.current);
      lookingForDyteChatInputAttempts.current = 0;
    };
  }, [isChatOpen]);
  /** As soon as the input box is found, a focus event listener is added to it that will have a callback that will emit an identical event, that will have
   * the input element as its 'target' property, and that will be visible at the document level. Without this, because the element is in a shadow dom,
   * events emitted from this element usually would not be have the element as its 'target' property. It would have the first ancestor outside the shadow dom as the 'target',
   * so we need to manually override that.
   */
  useEffect(function addListenersToDyteChatInput() {
    dyteChatInputElement === null || dyteChatInputElement === void 0 ? void 0 : dyteChatInputElement.addEventListener("focus", emitFocusEventWithCorrectTarget, {
      capture: true
    });
    return () => {
      dyteChatInputElement === null || dyteChatInputElement === void 0 ? void 0 : dyteChatInputElement.removeEventListener("focus", emitFocusEventWithCorrectTarget, {
        capture: true
      });
    };
  }, [dyteChatInputElement]);
  if (meeting) {
    return jsxs("div", Object.assign({
      className: classes.meetingContainer
    }, {
      children: [jsx("div", Object.assign({
        className: classes.buttonContainer
      }, {
        children: jsx(Button, Object.assign({
          color: "inherit",
          variant: "outlined",
          size: "medium",
          onClick: handleNavigateBack
        }, {
          children: "Back to Control Center"
        }))
      })), remoteSupportMeetingState.eStopStatus === "Triggered" && jsx("div", Object.assign({
        className: classes.estopStatusBannerContainer
      }, {
        children: jsx(Button, Object.assign({
          size: "medium",
          className: classes.estopStatusBannerButton,
          onClick: handleNavigateBack
        }, {
          children: "E-Stop Activated"
        }))
      })), jsx(DyteMeeting, {
        mode: "fill",
        meeting: meeting
      })]
    }));
  }
  return null;
};
const useStyles$7 = makeStyles(theme => ({
  meetingContainer: {
    height: "100%"
  },
  buttonContainer: {
    color: "white",
    position: "absolute",
    zIndex: 300,
    left: theme.spacing(12),
    top: theme.spacing(1)
  },
  estopStatusBannerContainer: {
    position: "absolute",
    zIndex: 300,
    top: theme.spacing(1),
    right: theme.spacing(3)
  },
  estopStatusBannerButton: {
    backgroundColor: theme.palette.error.main,
    borderRadius: theme.spacing(10),
    color: theme.palette.common.white,
    padding: theme.spacing(1, 6),
    "&:hover": {
      backgroundColor: darken(theme.palette.error.main, 0.2)
    }
  }
}));

const WaitingRoomIcon = () => {
  return jsxs("svg", Object.assign({
    width: "390",
    height: "152",
    viewBox: "0 0 390 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, {
    children: [jsx("rect", {
      x: "3.18799",
      y: "79.188",
      width: "4.25068",
      height: "72.2616",
      rx: "2.12534",
      fill: "#D3D9E0"
    }), jsx("rect", {
      x: "104.142",
      y: "79.188",
      width: "4.25068",
      height: "72.2616",
      rx: "2.12534",
      fill: "#D3D9E0"
    }), jsx("rect", {
      x: "94.5776",
      y: "40.9319",
      width: "4.25068",
      height: "24.4414",
      fill: "#D3D9E0"
    }), jsx("rect", {
      x: "14.8774",
      y: "40.9319",
      width: "4.25068",
      height: "24.4414",
      fill: "#D3D9E0"
    }), jsx("path", {
      d: "M8.50146 20.5504C8.50146 9.50473 17.4558 0.550415 28.5015 0.550415H84.1418C95.1875 0.550415 104.142 9.50472 104.142 20.5504V45.0502C104.142 47.6232 102.384 49.8631 99.8841 50.474C71.2638 57.4701 41.3795 57.4701 12.7591 50.474C10.2597 49.8631 8.50146 47.6232 8.50146 45.0502V20.5504Z",
      fill: "#1C344F"
    }), jsx("path", {
      d: "M0 75.1616C0 65.9597 7.97943 58.7896 17.129 59.7699L25.5051 60.6673C45.6376 62.8244 65.9428 62.8244 86.0752 60.6673L94.4514 59.7699C103.601 58.7896 111.58 65.9597 111.58 75.1616C111.58 81.9727 107.128 87.9835 100.613 89.9691L97.6937 90.8589C70.3782 99.1836 41.2022 99.1836 13.8867 90.8589L10.9671 89.9691C4.45188 87.9835 0 81.9727 0 75.1616Z",
      fill: "#1C344F"
    }), jsx("rect", {
      x: "142.398",
      y: "79.188",
      width: "4.25068",
      height: "72.2616",
      rx: "2.12534",
      fill: "#D3D9E0"
    }), jsx("rect", {
      x: "243.352",
      y: "79.188",
      width: "4.25068",
      height: "72.2616",
      rx: "2.12534",
      fill: "#D3D9E0"
    }), jsx("rect", {
      x: "233.788",
      y: "40.9319",
      width: "4.25068",
      height: "24.4414",
      fill: "#D3D9E0"
    }), jsx("rect", {
      x: "154.087",
      y: "40.9319",
      width: "4.25068",
      height: "24.4414",
      fill: "#D3D9E0"
    }), jsx("path", {
      d: "M147.711 20.5504C147.711 9.50473 156.666 0.550415 167.711 0.550415H223.352C234.397 0.550415 243.352 9.50472 243.352 20.5504V45.0502C243.352 47.6232 241.593 49.8631 239.094 50.474C210.474 57.4701 180.589 57.4701 151.969 50.474C149.47 49.8631 147.711 47.6232 147.711 45.0502V20.5504Z",
      fill: "#1C344F"
    }), jsx("path", {
      d: "M139.21 75.1616C139.21 65.9597 147.189 58.7896 156.339 59.7699L164.715 60.6673C184.848 62.8244 205.153 62.8244 225.285 60.6673L233.661 59.7699C242.811 58.7896 250.79 65.9597 250.79 75.1616C250.79 81.9727 246.338 87.9835 239.823 89.9691L236.904 90.8589C209.588 99.1836 180.412 99.1836 153.097 90.8589L150.177 89.9691C143.662 87.9835 139.21 81.9727 139.21 75.1616Z",
      fill: "#1C344F"
    }), jsx("rect", {
      x: "281.607",
      y: "79.188",
      width: "4.25068",
      height: "72.2616",
      rx: "2.12534",
      fill: "#D3D9E0"
    }), jsx("rect", {
      x: "382.561",
      y: "79.188",
      width: "4.25068",
      height: "72.2616",
      rx: "2.12534",
      fill: "#D3D9E0"
    }), jsx("rect", {
      x: "372.997",
      y: "40.9319",
      width: "4.25068",
      height: "24.4414",
      fill: "#D3D9E0"
    }), jsx("rect", {
      x: "293.297",
      y: "40.9319",
      width: "4.25068",
      height: "24.4414",
      fill: "#D3D9E0"
    }), jsx("path", {
      d: "M286.921 20.5504C286.921 9.50473 295.875 0.550415 306.921 0.550415H362.561C373.607 0.550415 382.561 9.50472 382.561 20.5504V45.0502C382.561 47.6232 380.803 49.8631 378.304 50.474C349.683 57.4701 319.799 57.4701 291.179 50.474C288.679 49.8631 286.921 47.6232 286.921 45.0502V20.5504Z",
      fill: "#1C344F"
    }), jsx("path", {
      d: "M278.419 75.1616C278.419 65.9597 286.399 58.7896 295.548 59.7699L303.925 60.6673C324.057 62.8244 344.362 62.8244 364.495 60.6673L372.871 59.7699C382.02 58.7896 390 65.9597 390 75.1616C390 81.9727 385.548 87.9835 379.033 89.9691L376.113 90.8589C348.798 99.1836 319.622 99.1836 292.306 90.8589L289.387 89.9691C282.871 87.9835 278.419 81.9727 278.419 75.1616Z",
      fill: "#1C344F"
    }), jsx("rect", {
      opacity: "0.7",
      x: "42",
      y: "20",
      width: "28",
      height: "14",
      fill: "url(#pattern0)"
    }), jsx("rect", {
      opacity: "0.7",
      x: "180",
      y: "20",
      width: "28",
      height: "14",
      fill: "url(#pattern1)"
    }), jsx("rect", {
      opacity: "0.7",
      x: "321",
      y: "20",
      width: "28",
      height: "14",
      fill: "url(#pattern2)"
    }), jsxs("defs", {
      children: [jsx("pattern", Object.assign({
        id: "pattern0",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
      }, {
        children: jsx("use", {
          xlinkHref: "#image0_1317_929",
          transform: "scale(0.00318097 0.00625)"
        })
      })), jsx("pattern", Object.assign({
        id: "pattern1",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
      }, {
        children: jsx("use", {
          xlinkHref: "#image0_1317_929",
          transform: "scale(0.00318097 0.00625)"
        })
      })), jsx("pattern", Object.assign({
        id: "pattern2",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
      }, {
        children: jsx("use", {
          xlinkHref: "#image0_1317_929",
          transform: "scale(0.00318097 0.00625)"
        })
      })), jsx("image", {
        id: "image0_1317_929",
        width: "1600",
        height: "160",
        xlinkHref: "data:image/png;base64,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"
      })]
    })]
  }));
};

var global$2 = global$C;
var classof = classof$4;

var String$1 = global$2.String;

var toString$1 = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String$1(argument);
};

var $ = _export;
var DESCRIPTORS = descriptors;
var global$1 = global$C;
var uncurryThis = functionUncurryThis;
var hasOwn = hasOwnProperty_1;
var isCallable = isCallable$i;
var isPrototypeOf = objectIsPrototypeOf;
var toString = toString$1;
var defineProperty = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$1.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var symbolToString = uncurryThis(SymbolPrototype.toString);
  var symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

const RemoteSupportLayout = props => {
  const classes = useStyles$6();
  return jsxs(FlexCentering, Object.assign({
    className: classes.root
  }, {
    children: [jsx(FlexCentering, {
      children: props.icon
    }), jsx(FlexCentering, {
      children: jsx(Typography, Object.assign({
        variant: "h1",
        className: classes.title
      }, {
        children: props.title
      }))
    }), jsx(FlexCentering, Object.assign({
      className: classes.description
    }, {
      children: props.description
    })), props.description2 && jsx(FlexCentering, Object.assign({
      className: classes.description
    }, {
      children: props.description2
    })), jsx(FlexCentering, {
      children: props.actionNode
    })]
  }));
};
const useStyles$6 = makeStyles(theme => ({
  root: {
    height: "100%",
    flexDirection: "column",
    gap: theme.spacing(4)
  },
  title: {
    fontWeight: 700,
    color: theme.palette.primary.main
  },
  description: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    color: theme.palette.primary.main
  }
}));

const RemoteSupportWaitingRoomPage = props => {
  const dispatch = useAppDispatch();
  const classes = useStyles$5();
  const navigate = useNavigate();
  const handleBackToControlCenter = () => {
    dispatch(remoteSupportMeetingSlice.actions.setRemoteSupportVisible(false));
    navigate(-1);
  };
  if (props.isJoiningSoon) return jsxs("div", Object.assign({
    className: classes.connectingSoon
  }, {
    children: [jsx(CircularProgress, {
      color: "secondary",
      size: 60
    }), jsx(Typography, Object.assign({
      variant: "h2"
    }, {
      children: "You have been paired with a Vention expert. You will be connected to a meeting momentarily."
    }))]
  }));
  return jsx(RemoteSupportLayout, {
    title: "You are in the remote support virtual waiting room",
    description: jsxs(Typography, Object.assign({
      variant: "h4"
    }, {
      children: ["A representative will be joining ", jsx("b", {
        children: "within 10 minutes"
      })]
    })),
    description2: jsxs(Fragment, {
      children: [jsx(Typography, Object.assign({
        variant: "h4"
      }, {
        children: "You can continue working while you hold and the call will connect once a representative joins"
      })), jsx(Typography, Object.assign({
        variant: "h4",
        className: classes.subtext
      }, {
        children: "The call will be recorded"
      }))]
    }),
    icon: jsx(WaitingRoomIcon, {}),
    actionNode: jsxs("div", Object.assign({
      className: classes.buttonContainer
    }, {
      children: [jsx(Button, Object.assign({
        color: "primary",
        variant: "contained",
        size: "medium",
        onClick: handleBackToControlCenter
      }, {
        children: "Back to Control Center"
      })), jsx(Button, Object.assign({
        className: classes.cancelButton,
        variant: "contained",
        size: "medium",
        onClick: props.handleCancelCallRequest
      }, {
        children: "Cancel Call Request & Exit"
      }))]
    }))
  });
};
const useStyles$5 = makeStyles(theme => ({
  buttonContainer: {
    display: "grid",
    gap: theme.spacing(2)
  },
  cancelButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
    "&:hover": {
      background: darken(theme.palette.error.main, 0.1)
    }
  },
  subtext: {
    paddingTop: theme.spacing(4),
    color: theme.palette.grey[500]
  },
  connectingSoon: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(4)
  }
}));

const RemoteSupportOverlay = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const remoteSupportMeetingState = useAppSelector(state => state.remoteSupportMeetingReducer);
  const [isJoiningSoon, setIsJoiningSoon] = useState(false);
  const {
    meeting
  } = useDyteMeeting();
  const waitlistStatus = useDyteSelector(meeting => meeting.self.waitlistStatus);
  const [waitingRoomTimer, setWaitingRoomTimer] = useState(null);
  const fiveMinutesInMs = 1000 * 60 * 5;
  const openNoOneAvailableDialog = () => {
    dispatch(dialogsSlice.actions.add({
      name: NoOneAvailableDialog.name,
      content: jsx(NoOneAvailableDialog, {
        onDialogueClose: () => {
          setWaitingRoomTimer(null);
        },
        onCancelClick: openCancelMeetingConfirmationDialog
      }),
      priority: "regular",
      maxWidth: "lg",
      hasCloseButton: false,
      isManualCloseDisabled: true
    }));
  };
  const openCancelMeetingConfirmationDialog = () => {
    dispatch(dialogsSlice.actions.add({
      name: CancelMeetingConfirmationDialog.name,
      content: jsx(CancelMeetingConfirmationDialog, {
        onCancelClick: handleCancelCallRequest
      }),
      priority: "high",
      maxWidth: "lg",
      hasCloseButton: false,
      isManualCloseDisabled: true
    }));
  };
  const closeNoOneAvailableDialog = () => {
    dispatch(dialogsSlice.actions.remove({
      name: NoOneAvailableDialog.name
    }));
  };
  const closeCancelMeetingConfirmationDialog = () => {
    dispatch(dialogsSlice.actions.remove({
      name: CancelMeetingConfirmationDialog.name
    }));
  };
  /**
   * When a CS representative admits the user into the meeting room, it can take up to 10 seconds for the Dyte meeting to appear.
   * During this time, we don't want the user to leave the waiting room so we display a screen that reflects that they
   * are about to enter a meeting with an agent.
   */
  const handleJoiningRoomSoon = () => {
    closeNoOneAvailableDialog();
    closeCancelMeetingConfirmationDialog();
    setIsJoiningSoon(true);
    clearTimeout(waitingRoomTimer);
    dispatch(remoteSupportMeetingSlice.actions.setRemoteSupportVisible(true));
    if (location.pathname !== "/remote-support") navigate("/remote-support");
  };
  const handleCancelCallRequest = async () => {
    await meeting.leaveRoom();
    meeting.meta.emit("disconnected");
    closeNoOneAvailableDialog();
    closeCancelMeetingConfirmationDialog();
    clearTimeout(waitingRoomTimer);
  };
  useEffect(function checkIfConnectionInitiatedAndSetTimerNull() {
    if (remoteSupportMeetingState.isConnectionInitiated) {
      setWaitingRoomTimer(null);
    }
  }, [remoteSupportMeetingState.isConnectionInitiated]);
  // If a user dismisses the dialogue, or if a user has initiated a connection, waitingRoomTimer will be set to null, which will trigger this useEffect and start a new timer.
  useEffect(function setWaitingRoomTimerIfTimerNull() {
    if (!waitingRoomTimer) {
      setWaitingRoomTimer(setTimeout(() => {
        openNoOneAvailableDialog();
      }, fiveMinutesInMs));
    }
    return () => {
      clearTimeout(waitingRoomTimer);
    };
  }, [waitingRoomTimer]);
  useEffect(function checkWaitlistStatusAndHandle() {
    if (remoteSupportMeetingState.isInWaitingRoom) {
      if (waitlistStatus === "waiting") {
        setIsJoiningSoon(false);
      }
      if (waitlistStatus === "accepted") {
        handleJoiningRoomSoon();
      }
    }
  }, [waitlistStatus, remoteSupportMeetingState.isInWaitingRoom]);
  const classes = useStyles$4({
    isScreenSharing: remoteSupportMeetingState.isScreenSharing
  })();
  if (remoteSupportMeetingState.isRemoteSupportConnected && !remoteSupportMeetingState.isConnectionInitiated) {
    return jsxs("div", Object.assign({
      className: clsx(classes.dyteContainer, remoteSupportMeetingState.isScreenSharing && classes.dyteOverlayBorder, remoteSupportMeetingState.isRemoteSupportVisible ? classes.visible : classes.hidden)
    }, {
      children: [jsx(RemoteSupportMeetingPage, {}), remoteSupportMeetingState.isInWaitingRoom && jsx("div", Object.assign({
        className: classes.waitingRoom
      }, {
        children: jsx(RemoteSupportWaitingRoomPage, {
          handleCancelCallRequest: openCancelMeetingConfirmationDialog,
          isJoiningSoon: isJoiningSoon
        })
      }))]
    }));
  }
  return null;
};
const useStyles$4 = props => makeStyles(theme => Object.assign({
  dyteContainer: {
    position: "absolute",
    top: "0",
    width: "100%",
    height: "100%",
    zIndex: 300
  },
  waitingRoom: {
    position: "absolute",
    top: "0",
    width: "100%",
    height: "100%",
    zIndex: 301,
    backgroundColor: theme.palette.common.white
  },
  visible: {
    visibility: "visible"
  },
  hidden: {
    visibility: "hidden"
  },
  liveMeetingIndicator: {
    position: "absolute",
    top: "0",
    right: "0",
    backgroundColor: theme.palette.error.main,
    margin: theme.spacing(1)
  },
  dyteOverlayBorder: {
    border: `5px ${theme.palette.secondary.main} solid`,
    boxSizing: "border-box"
  }
}, props.isScreenSharing ? {
  "@global": {
    "#root": {
      position: "relative"
    },
    "#root::before": {
      content: '""',
      position: "absolute",
      top: "0",
      right: "0",
      bottom: "0",
      left: "0",
      border: `5px ${theme.palette.secondary.main} solid`,
      pointerEvents: "none"
    }
  }
} : {}));

const RemoteSupportOverlayWrapper = () => {
  const {
    dyteClient
  } = useDyte();
  return jsx(DyteProvider, Object.assign({
    value: dyteClient,
    fallback: null
  }, {
    children: jsx(RemoteSupportOverlay, {})
  }));
};

const ecommercePendantEndpoints = ecommerceApi.injectEndpoints({
  endpoints: build => ({
    getMachineDeploymentForMachine: build.query({
      query: params => ({
        url: `/api/v3/machines/${params.serialNumber}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${params.token}`,
          Accept: "application/json"
        }
      }),
      providesTags: [ecommerceTagTypes.machineDeploymentForMachine]
    }),
    getClientDetail: build.query({
      query: params => ({
        url: `/api/v3/machines/${params.serialNumber}/client-details`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${params.token}`,
          Accept: "application/json"
        }
      })
    })
  })
});
const {
  useGetMachineDeploymentForMachineQuery,
  useGetClientDetailQuery
} = ecommercePendantEndpoints;

const useInBusinessHours = (param, config) => {
  const {
    data,
    isLoading,
    isError
  } = useAskForBusinessHoursQuery(param, config);
  const now = dayjs().tz(data === null || data === void 0 ? void 0 : data.dayjsTimeZone);
  const workHours = data === null || data === void 0 ? void 0 : data.workHours;
  const displayTimeZone = data === null || data === void 0 ? void 0 : data.displayTimeZone;
  const inBusinessHours = now.hour() >= (workHours === null || workHours === void 0 ? void 0 : workHours.start) && now.hour() < (workHours === null || workHours === void 0 ? void 0 : workHours.end) && now.day() >= 1 && now.day() <= 5;
  return {
    inBusinessHours,
    isLoading,
    isError,
    workHours,
    now,
    displayTimeZone
  };
};

const ThumbsDownIcon = () => {
  return jsx("svg", Object.assign({
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M17.4606 7.95646C17.6539 7.17121 17.56 6.20286 17.1221 5.51644C17.2738 4.68084 17.0132 3.78053 16.4814 3.15728C16.5489 1.26218 15.3896 8.92542e-07 13.3055 0.00049308C13.1873 -0.000561607 12.0572 0.000387611 11.8637 0.00049308C9.16147 -0.000245201 6.88771 1.40625 5.625 1.40625H5.24373C5.04545 1.23135 4.78522 1.125 4.5 1.125H1.125C0.503684 1.125 0 1.62868 0 2.25V11.25C0 11.8713 0.503684 12.375 1.125 12.375H4.5C5.12132 12.375 5.625 11.8713 5.625 11.25V10.8112C5.65488 10.8206 5.68311 10.8305 5.70874 10.8413C6.46875 11.25 7.73388 13.2627 8.56252 14.0913C8.91056 14.4394 9.0237 15.0209 9.14347 15.6365C9.34397 16.6669 9.73529 18 10.7898 18C12.8854 18 13.7046 16.7811 13.7046 14.7277C13.7046 13.6411 13.2836 12.8837 12.977 12.2732H15.4432C16.8725 12.2732 18 11.0463 18 9.72183C18 9 17.8096 8.40906 17.4606 7.95646V7.95646ZM4.5 11.25H1.125V2.25H4.5V11.25ZM15.4432 11.1481H11.5057C11.5057 12.5799 12.5796 13.2444 12.5796 14.7276C12.5796 15.6267 12.5796 16.8754 10.7898 16.8754C10.0739 16.1594 10.4318 14.3697 9.358 13.2958C8.35228 12.2901 6.85234 9.71631 5.77846 9.71631H5.625V2.55727H5.77846C6.99841 2.55727 9.358 1.12546 11.8637 1.12546C11.986 1.12546 13.179 1.1244 13.2955 1.12546C14.6402 1.1384 15.5984 1.77353 15.3068 3.62064C15.8822 3.92931 16.3101 4.99999 15.8347 5.80018C16.5937 6.1875 16.5937 7.875 16.0318 8.2845C16.5937 8.4375 16.8785 9.00042 16.875 9.71631C16.8715 10.4322 16.2423 11.1481 15.4432 11.1481ZM3.65625 9.5625C3.65625 10.0285 3.2785 10.4063 2.8125 10.4063C2.3465 10.4063 1.96875 10.0285 1.96875 9.5625C1.96875 9.0965 2.3465 8.71875 2.8125 8.71875C3.2785 8.71875 3.65625 9.0965 3.65625 9.5625Z",
      fill: "#1C344F"
    })
  }));
};

const ThumbsUpIcon = () => {
  return jsx("svg", Object.assign({
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M0.538827 10.0435C0.345538 10.8288 0.439406 11.7971 0.877278 12.4836C0.725613 13.3192 0.986225 14.2195 1.518 14.8427C1.4505 16.7378 2.60974 18 4.69387 17.9995C4.81211 18.0006 5.9422 17.9996 6.13574 17.9995C8.83792 18.0002 11.1117 16.5937 12.3744 16.5937L12.7557 16.5937C12.9539 16.7687 13.2142 16.875 13.4994 16.875L16.8744 16.875C17.4957 16.875 17.9994 16.3713 17.9994 15.75L17.9994 6.75C17.9994 6.12868 17.4957 5.625 16.8744 5.625L13.4994 5.625C12.8781 5.625 12.3744 6.12868 12.3744 6.75L12.3744 7.18878C12.3445 7.17943 12.3163 7.16948 12.2906 7.15869C11.5306 6.75 10.2655 4.7373 9.43688 3.90867C9.08883 3.56062 8.9757 2.97914 8.85592 2.36352C8.65542 1.33305 8.2641 -8.51086e-07 7.20959 -9.43275e-07C5.11399 -1.12648e-06 4.29482 1.21893 4.29482 3.27234C4.29482 4.35888 4.71581 5.11625 5.02238 5.72685L2.55616 5.72685C1.12692 5.72685 -0.000609386 6.95366 -0.000643834 8.27817C-0.000609565 9 0.189832 9.59094 0.538827 10.0435ZM13.4994 6.75L16.8744 6.75L16.8744 15.75L13.4994 15.75L13.4994 6.75ZM2.5562 6.85188L6.49366 6.85188C6.49366 5.42007 5.41982 4.75558 5.41982 3.27238C5.41982 2.37329 5.41982 1.12465 7.20959 1.12465C7.92547 1.84057 7.56755 3.6303 8.64139 4.70415C9.64711 5.70987 11.1471 8.28369 12.2209 8.28369L12.3744 8.28369L12.3744 15.4427L12.2209 15.4427C11.001 15.4427 8.64139 16.8745 6.13574 16.8745C6.01339 16.8745 4.82037 16.8756 4.70393 16.8745C3.35917 16.8616 2.40102 16.2265 2.69257 14.3794C2.11717 14.0707 1.68928 13 2.1647 12.1998C1.40564 11.8125 1.40564 10.125 1.96754 9.7155C1.40564 9.5625 1.12088 8.99958 1.12439 8.28369C1.12791 7.56777 1.7571 6.85188 2.5562 6.85188ZM14.3431 8.4375C14.3431 7.9715 14.7209 7.59375 15.1869 7.59375C15.6529 7.59375 16.0306 7.9715 16.0306 8.4375C16.0306 8.90349 15.6529 9.28125 15.1869 9.28125C14.7209 9.28125 14.3431 8.90349 14.3431 8.4375Z",
      fill: "#1C344F"
    })
  }));
};

const RemoteSupportSurveyQuestion = props => {
  const classes = useStyles$3();
  return jsxs(Fragment, {
    children: [jsx(Typography, Object.assign({
      variant: "subtitle1",
      className: classes.title
    }, {
      children: props.question
    })), jsx(FlexCentering, Object.assign({
      className: clsx(classes.ratingContainer, props.isInvalid && classes.warningBorder)
    }, {
      children: range(1, 11).map(rating => jsx(Box, Object.assign({
        onClick: () => props.onRatingChange(rating),
        className: clsx(classes.ratingItem, rating !== 10 && classes.ratingItemBorder, rating === props.selectedRating && classes.selectedRating, props.isInvalid && classes.warningBorder)
      }, {
        children: rating
      }), rating))
    })), jsxs(FlexCentering, Object.assign({
      className: classes.thumbsContainer
    }, {
      children: [jsxs(FlexCentering, Object.assign({
        className: classes.thumbSpacing
      }, {
        children: [jsx(ThumbsDownIcon, {}), jsx(Typography, Object.assign({
          variant: "h6"
        }, {
          children: props.poorFeedbackText
        }))]
      })), props.isInvalid && jsx(Typography, Object.assign({
        variant: "h6",
        className: classes.warningText
      }, {
        children: "This field is required"
      })), jsxs(FlexCentering, Object.assign({
        className: classes.thumbSpacing
      }, {
        children: [jsx(Typography, Object.assign({
          variant: "h6"
        }, {
          children: props.goodFeedbackText
        })), jsx(ThumbsUpIcon, {})]
      }))]
    }))]
  });
};
const useStyles$3 = makeStyles(theme => ({
  title: {
    paddingTop: theme.spacing(2)
  },
  ratingContainer: {
    border: "1px solid",
    borderColor: theme.palette.grey["200"],
    borderRadius: 3,
    width: "100%"
  },
  ratingItem: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: theme.spacing(4),
    width: "10%",
    "&:hover": {
      background: darken(theme.palette.background.default, 0.1),
      cursor: "pointer"
    }
  },
  ratingItemBorder: {
    borderRight: "1px solid",
    borderRightColor: theme.palette.grey["200"]
  },
  selectedRating: {
    background: theme.palette.primary.main,
    "&:hover": {
      background: darken(theme.palette.primary.main, 0.2),
      cursor: "pointer"
    },
    color: theme.palette.common.white
  },
  thumbsContainer: {
    width: "100%",
    justifyContent: "space-between"
  },
  thumbSpacing: {
    gap: theme.spacing(1)
  },
  warningBorder: {
    borderColor: theme.palette.error.main
  },
  warningText: {
    color: theme.palette.error.main
  }
}));

const RemoteSupportFeedbackPage = () => {
  const navigate = useNavigate();
  const classes = useStyles$2();
  const [updateZendeskTicketMeetingEnd] = useUpdateZendeskTicketMeetingEndMutation();
  const remoteSupportMeetingState = useAppSelector(state => state.remoteSupportMeetingReducer);
  const dispatch = useAppDispatch();
  const [satisfactionRating, setSatisfactionRating] = useState(null);
  const [isSatisfactionRatingInvalid, setSatisfactionRatingInvalid] = useState(false);
  const {
    data: railsTokenData
  } = remoteSupportApiEndpoints.endpoints.getRailsToken.useQueryState();
  /**
   * Because using the keyboard to input characters does not trigger any observable event in the context of React (onChange, onInput, etc...), we need can only receive the users input by extracting
   * the value property of the HTML input element after they have completed entering their feedback.
   * @returns The text that the user entered into the feedback input box
   */
  const getFeedbackText = () => {
    const inputElement = document.getElementById("feedbackText");
    return inputElement.value;
  };
  const handleSatisfactionRatingChange = satisfactionRating => {
    setSatisfactionRating(satisfactionRating);
    setSatisfactionRatingInvalid(false);
  };
  const submitSurvey = () => {
    if (!satisfactionRating) {
      setSatisfactionRatingInvalid(true);
      return;
    }
    const feedbackText = getFeedbackText();
    updateZendeskTicketMeetingEnd({
      updateInfo: {
        meetingId: remoteSupportMeetingState.meetingId,
        satisfactionRating: satisfactionRating,
        callDuration: remoteSupportMeetingState.callDuration,
        verbatimFeedback: feedbackText
      },
      token: railsTokenData === null || railsTokenData === void 0 ? void 0 : railsTokenData.token
    });
    dispatch(remoteSupportMeetingSlice.actions.resetRemoteSupport());
    dispatch(snackbarSlice.actions.display({
      message: "Thank you for your feedback!",
      severity: "success"
    }));
    navigate("/");
  };
  return jsx("div", Object.assign({
    className: classes.container
  }, {
    children: jsxs("div", Object.assign({
      className: classes.contentArea
    }, {
      children: [jsxs(FlexCentering, {
        children: [jsx(RemoteSupportIcon, {
          scale: 0.4
        }), jsxs("div", Object.assign({
          className: classes.callDuration
        }, {
          children: [jsx(Typography, Object.assign({
            variant: "h1"
          }, {
            children: "Call ended"
          })), jsxs(Typography, Object.assign({
            variant: "subtitle1"
          }, {
            children: ["Duration: ", remoteSupportMeetingState.callDuration]
          }))]
        }))]
      }), jsx(RemoteSupportSurveyQuestion, {
        question: "How would you rate the support you received?",
        selectedRating: satisfactionRating,
        onRatingChange: handleSatisfactionRatingChange,
        poorFeedbackText: "Not at all satisfied",
        goodFeedbackText: "Extremely satisfied",
        isInvalid: isSatisfactionRatingInvalid
      }), jsxs(Typography, Object.assign({
        variant: "subtitle1"
      }, {
        children: ["Please tell us why you gave us this rating ", jsx("i", {
          children: "(optional)"
        })]
      })), jsx(TextField, {
        fullWidth: true,
        variant: "outlined",
        id: "feedbackText",
        multiline: true
      }), jsx(Button, Object.assign({
        className: classes.submitButton,
        color: "primary",
        variant: "contained",
        size: "medium",
        onClick: () => submitSurvey()
      }, {
        children: "Submit & Back to Control Center"
      })), jsxs(Typography, Object.assign({
        variant: "subtitle1"
      }, {
        children: ["Get Vention support by emailing ", jsx("b", {
          children: "integrationsupport@vention.cc"
        }), " or calling ", jsx("b", {
          children: "1-800-940-3617"
        })]
      }))]
    }))
  }));
};
const useStyles$2 = makeStyles(theme => ({
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.primary.main
  },
  contentArea: {
    height: "100%",
    width: "70%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(2)
  },
  callDuration: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "left",
    paddingLeft: theme.spacing(3)
  },
  submitButton: {
    marginTop: theme.spacing(2)
  }
}));

const NoInternetIcon = () => {
  return jsxs("svg", Object.assign({
    width: "123",
    height: "97",
    viewBox: "0 0 123 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("g", Object.assign({
      clipPath: "url(#clip0_1_1082)"
    }, {
      children: jsx("path", {
        d: "M62.3097 60.7C62.0406 60.681 61.7715 60.6242 61.5025 60.6242C53.0078 60.6242 46.1275 67.4066 46.1275 75.7804C46.1275 84.1543 53.0078 90.9367 61.5025 90.9367C69.9971 90.9367 76.8775 84.1543 76.8775 75.7804C76.8775 74.2648 76.5892 72.8439 76.1664 71.4609L62.3097 60.7ZM61.5025 84.8742C56.4095 84.8742 52.2775 80.8009 52.2775 75.7804C52.2775 70.7599 56.4095 66.6867 61.5025 66.6867C66.5954 66.6867 70.7275 70.7599 70.7275 75.7804C70.7275 80.8009 66.5954 84.8742 61.5025 84.8742ZM0.732769 29.9328C-0.20895 30.8232 -0.247387 32.3009 0.675113 33.2103L1.77058 34.2902C2.65464 35.1617 4.09605 35.1806 4.99933 34.347C8.67011 30.9179 12.5907 27.9246 16.6843 25.2912L11.6106 21.3506C7.84371 23.9271 4.17292 26.7121 0.732769 29.9328ZM118.006 34.347C118.909 35.1996 120.35 35.1806 121.234 34.2902L122.33 33.2103C123.252 32.3009 123.233 30.8232 122.272 29.9328C96.7881 6.09958 60.3685 0.112866 29.3879 11.9916L35.192 16.5006C63.2129 7.17947 95.289 13.1094 118.006 34.347ZM60.8298 36.3931L69.4014 43.0619C79.3567 44.5207 88.966 48.7076 96.9418 55.6984C97.8643 56.5131 99.2865 56.4562 100.132 55.5658L101.189 54.467C102.092 53.5386 102.035 52.0609 101.055 51.2084C89.6387 41.1674 75.2246 36.2416 60.8298 36.3931ZM122.426 91.9218L4.42277 0.34021C3.76933 -0.190258 2.78918 -0.0955319 2.27027 0.567554L0.348394 2.93572C-0.189731 3.5988 -0.0744186 4.54607 0.579019 5.05759L118.582 96.6582C119.236 97.1886 120.216 97.075 120.735 96.4308L122.657 94.0627C123.195 93.3996 123.099 92.4523 122.426 91.9218ZM21.9118 51.2084C20.9509 52.0609 20.8932 53.5386 21.7965 54.467L22.8535 55.5658C23.7184 56.4562 25.1214 56.5131 26.0631 55.6984C31.0215 51.341 36.7679 47.9498 42.9948 45.6953L37.479 41.4136C31.9056 43.8197 26.6396 47.0593 21.9118 51.2084Z",
        fill: "#1C344F"
      })
    })), jsx("defs", {
      children: jsx("clipPath", Object.assign({
        id: "clip0_1_1082"
      }, {
        children: jsx("rect", {
          width: "123",
          height: "97",
          fill: "white"
        })
      }))
    })]
  }));
};

const RemoteSupportNoInternetPage = () => {
  const navigate = useNavigate();
  return jsx(RemoteSupportLayout, {
    title: "No Internet Connection",
    description: !navigator.onLine ? jsxs(Fragment, {
      children: [jsx(Typography, Object.assign({
        variant: "h4"
      }, {
        children: "You must connect your internet in order to use the remote support feature."
      })), jsx(Typography, Object.assign({
        variant: "h4"
      }, {
        children: "You can do this in the network section of the control center."
      }))]
    }) : jsxs(Fragment, {
      children: [jsx(Typography, Object.assign({
        variant: "h4"
      }, {
        children: "Your Machine Motion is not connected to the internet."
      })), jsx(Typography, Object.assign({
        variant: "h4"
      }, {
        children: "Your Machine Motion needs to be connected to the internet to initiate Remote Support"
      }))]
    }),
    icon: jsx(NoInternetIcon, {}),
    actionNode: jsx(Button, Object.assign({
      color: "primary",
      variant: "contained",
      size: "medium",
      onClick: () => navigate("/")
    }, {
      children: "Connect To Internet"
    }))
  });
};

const RemoteSupportNoSubscriptionPage = () => {
  const navigate = useNavigate();
  return jsx(RemoteSupportLayout, {
    title: "You need a subscription to access remote support",
    description: jsxs(Fragment, {
      children: [jsx(Typography, Object.assign({
        variant: "h4"
      }, {
        children: "If you would like to inquire about remote support, contact us"
      })), jsxs(Typography, Object.assign({
        variant: "h4"
      }, {
        children: ["at ", jsx("b", {
          children: "integrationsupport@vention.cc"
        }), " or ", jsx("b", {
          children: "1-800-940-3617"
        })]
      }))]
    }),
    icon: jsx(RemoteSupportIcon, {}),
    actionNode: jsx(Button, Object.assign({
      variant: "contained",
      color: "primary",
      onClick: () => navigate("/")
    }, {
      children: "Back to Control Center"
    }))
  });
};

const OutsideBusinessHoursIcon = () => {
  return jsxs("svg", Object.assign({
    width: "131",
    height: "141",
    viewBox: "0 0 147 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      d: "M18.8212 108.011C7.43082 108.011 2.95755 100.345 2.05841 96.2437C2.0162 96.0512 2 95.8567 2 95.6596V68.3323C2 67.6982 2.1877 67.0783 2.53944 66.5507L5.53293 62.0604C5.79118 61.673 5.95857 61.2477 6.03604 60.7886C9.30486 41.419 25.816 4 67.0419 4C108.202 4 122.724 41.2987 124.99 60.695C125.05 61.2143 125.227 61.6998 125.517 62.1348L128.461 66.5507C128.812 67.0783 129 67.6982 129 68.3323V95.6596C129 95.8567 128.985 96.0513 128.938 96.2427C127.934 100.344 121.248 108.011 113.581 108.011",
      stroke: "#1C344F",
      strokeWidth: "3.93"
    }), jsx("path", {
      d: "M18.5408 58.669C22.0919 44.9316 37.0441 17.457 66.2008 17.457C95.3575 17.457 109.188 44.9316 114.141 58.669",
      stroke: "#1C344F",
      strokeWidth: "3.93"
    }), jsx("rect", {
      x: "94.5167",
      y: "49.978",
      width: "22.4283",
      height: "63.9205",
      rx: "8.56512",
      fill: "#1C344F"
    }), jsx("rect", {
      x: "94.5167",
      y: "49.978",
      width: "22.4283",
      height: "63.9205",
      rx: "8.56512",
      fill: "#1C344F"
    }), jsx("rect", {
      x: "15.4569",
      y: "49.978",
      width: "22.4283",
      height: "63.9205",
      rx: "8.56512",
      fill: "#1C344F"
    }), jsx("rect", {
      x: "15.4569",
      y: "49.978",
      width: "22.4283",
      height: "63.9205",
      rx: "8.56512",
      fill: "#1C344F"
    }), jsx("path", {
      d: "M114.702 108.011C114.328 113.431 108.029 126.683 85.8254 136.327",
      stroke: "#1C344F",
      strokeWidth: "3.93"
    }), jsx("rect", {
      x: "61.4351",
      y: "126.795",
      width: "28.0353",
      height: "15.6998",
      rx: "7.84989",
      fill: "#1AC876"
    }), jsx("circle", {
      cx: "126.5",
      cy: "20.5",
      r: "20.5",
      fill: "white"
    }), jsx("path", {
      d: "M126.5 3C116.826 3 109 10.8264 109 20.5C109 30.1736 116.826 38 126.5 38C136.174 38 144 30.1736 144 20.5C144 10.8264 136.174 3 126.5 3ZM126.5 34.1111C118.99 34.1111 112.889 28.0104 112.889 20.5C112.889 12.9896 118.99 6.88889 126.5 6.88889C134.01 6.88889 140.111 12.9896 140.111 20.5C140.111 28.0104 134.01 34.1111 126.5 34.1111ZM134.099 20.5556L128.444 18.7292V11.9566C128.444 11.3125 127.91 10.7778 127.266 10.7778H125.734C125.09 10.7778 124.556 11.3125 124.556 11.9566V21.2656C124.556 21.9097 125.09 22.4444 125.734 22.4444L133.099 24.4444C133.743 24.4444 134.222 24.2344 134.5 23.5L135.278 21.7344C135.5 21 134.195 20.5556 134.099 20.5556Z",
      fill: "#1C344F"
    })]
  }));
};

const convertToTwelveHour = hour => {
  if (hour === 0) {
    return "12am";
  }
  const hourTwelve = hour % 12;
  const suffix = hour >= 12 ? "pm" : "am";
  return hourTwelve + suffix;
};
const RemoteSupportNotInBusinessHoursPage = props => {
  const navigate = useNavigate();
  return jsx(RemoteSupportLayout, {
    title: "Currently outside remote support business hours",
    description: jsxs(Fragment, {
      children: [jsxs(Typography, Object.assign({
        variant: "h4"
      }, {
        children: ["Remote support business hours are", " ", jsxs("b", {
          children: [convertToTwelveHour(props.workHours.start), " ", props.displayTimeZone, " to ", convertToTwelveHour(props.workHours.end), " ", props.displayTimeZone, " "]
        }), "Monday-Friday."]
      })), jsx(Typography, Object.assign({
        variant: "h4"
      }, {
        children: "Please call back during business hours and we will be happy to assist you."
      }))]
    }),
    icon: jsx(OutsideBusinessHoursIcon, {}),
    actionNode: jsx(Button, Object.assign({
      color: "primary",
      variant: "contained",
      size: "medium",
      onClick: () => navigate("/")
    }, {
      children: "Back to Control Center"
    })),
    description2: jsxs(Fragment, {
      children: [jsxs(Typography, Object.assign({
        variant: "subtitle1",
        align: "center"
      }, {
        children: ["In the meantime, you can refer to our resource center at ", jsx("b", {
          children: "vention.io/resources"
        }), " or you can"]
      })), jsxs(Typography, Object.assign({
        variant: "subtitle1",
        align: "center"
      }, {
        children: ["contact ", jsx("b", {
          children: "integrationsupport@vention.cc"
        })]
      }))]
    })
  });
};

const PendantIcon = () => {
  return jsxs("svg", Object.assign({
    width: "213",
    height: "156",
    viewBox: "0 0 142 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      d: "M0 17.5716C0 15.5068 1.67384 13.8329 3.73863 13.8329H35.4702H53.2054H58.76C60.6434 13.8329 62.2229 12.4112 62.4205 10.5383L63.2872 6.41588C63.5596 5.12057 64.1634 3.9181 65.0396 2.92604C65.8033 2.06141 66.7527 1.38072 67.8167 0.934932L68.5703 0.61921L69.2383 0.444696C70.3546 0.153062 71.5269 0.151161 72.6441 0.439173C73.2875 0.60503 73.9031 0.864569 74.471 1.20947L74.6302 1.30616C75.7201 1.96807 76.6369 2.87973 77.3049 3.96586L77.5082 4.29638C78.1363 5.31758 78.5686 6.44691 78.7829 7.62651L79.3203 10.585C79.6007 12.4519 81.2045 13.8329 83.0924 13.8329H88.6756H106.411H138.142C140.207 13.8329 141.881 15.5068 141.881 17.5716V99.9149C141.881 101.98 140.207 103.653 138.142 103.653H3.73863C1.67385 103.653 0 101.98 0 99.9149V17.5716Z",
      fill: "url(#paint0_linear_1967_1204)"
    }), jsx("rect", {
      x: "6.4491",
      y: "21.9644",
      width: "128.983",
      height: "73.5575",
      rx: "0.373863",
      fill: "#4B4B4B"
    }), jsx("rect", {
      x: "7.1969",
      y: "22.6187",
      width: "127.487",
      height: "72.249",
      rx: "0.373863",
      fill: "black"
    }), jsxs("g", Object.assign({
      opacity: "0.9"
    }, {
      children: [jsx("circle", {
        cx: "70.9708",
        cy: "7.63369",
        r: "6.79262",
        fill: "#DD454D"
      }), jsx("circle", {
        cx: "70.9261",
        cy: "7.67845",
        r: "2.01097",
        fill: "#E8E8E9"
      }), jsx("path", {
        d: "M72.9371 2.27124C75.0612 2.93947 76.6015 4.9225 76.6015 7.26488C76.6015 7.57359 76.5748 7.87606 76.5234 8.1701",
        stroke: "#E8E8E9",
        strokeWidth: "0.841192"
      }), jsx("path", {
        d: "M65.2953 8.4834C64.812 6.30975 65.7592 3.98427 67.7877 2.81308C68.0551 2.65873 68.3304 2.53066 68.6107 2.42809",
        stroke: "#E8E8E9",
        strokeWidth: "0.841192"
      }), jsx("path", {
        d: "M74.4258 12.1025C72.7851 13.608 70.2976 13.9504 68.269 12.7792C68.0017 12.6249 67.7531 12.4505 67.5241 12.259",
        stroke: "#E8E8E9",
        strokeWidth: "0.841192"
      })]
    })), jsx("path", {
      d: "M70.0059 20.9361C70.0059 20.4199 70.4243 20.0015 70.9405 20.0015C71.4567 20.0015 71.8752 20.4199 71.8752 20.9361V22.6185H70.0059V20.9361Z",
      fill: "#4B4B4B"
    }), jsx("defs", {
      children: jsxs("linearGradient", Object.assign({
        id: "paint0_linear_1967_1204",
        x1: "-9.44002",
        y1: "8.739",
        x2: "137.909",
        y2: "77.7634",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [jsx("stop", {
          stopColor: "#84ACC8"
        }), jsx("stop", {
          offset: "1",
          stopColor: "#4E6B84"
        })]
      }))
    })]
  }));
};

const RemoteSupportNotOnPendantPage = () => {
  const navigate = useNavigate();
  return jsx(RemoteSupportLayout, {
    title: "Please use the Vention Pendant to access Remote Support",
    description: jsx(Typography, Object.assign({
      variant: "h4"
    }, {
      children: "Remote Support cannot be accessed using a laptop. Please use your teach pendant or call for support."
    })),
    icon: jsx(PendantIcon, {}),
    actionNode: jsx(Button, Object.assign({
      color: "primary",
      variant: "contained",
      size: "medium",
      onClick: () => navigate("/")
    }, {
      children: "Back to Control Center"
    }))
  });
};

const QuestionCircleIcon = () => jsx("svg", Object.assign({
  width: "103",
  height: "103",
  viewBox: "0 0 103 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, {
  children: jsx("path", {
    d: "M51.5 68.3984C48.3891 68.3984 45.8672 70.9203 45.8672 74.0312C45.8672 77.1422 48.3891 79.6641 51.5 79.6641C54.6109 79.6641 57.1328 77.1422 57.1328 74.0312C57.1328 70.9203 54.6109 68.3984 51.5 68.3984ZM53.043 63.5703H49.8242C48.4911 63.5703 47.4102 62.4894 47.4102 61.1562V61.0796C47.4102 46.9286 62.9889 48.2812 62.9889 39.4721C62.9889 35.4455 59.4159 31.3828 51.4336 31.3828C45.5707 31.3828 42.5287 33.3239 39.522 37.1548C38.7358 38.1567 37.2983 38.3609 36.2534 37.6328L33.6112 35.7921C32.4796 35.0037 32.2312 33.4241 33.0791 32.3366C37.3492 26.8593 42.4155 23.3359 51.4336 23.3359C61.9589 23.3359 71.0358 29.321 71.0358 39.4721C71.0358 53.0339 55.4571 52.3168 55.4571 61.0796V61.1562C55.4571 62.4894 54.3762 63.5703 53.043 63.5703ZM51.5 8.04688C75.3632 8.04688 94.9531 27.3745 94.9531 51.5C94.9531 75.498 75.5179 94.9531 51.5 94.9531C27.5115 94.9531 8.04688 75.5276 8.04688 51.5C8.04688 27.5197 27.4805 8.04688 51.5 8.04688ZM51.5 1.60938C23.9481 1.60938 1.60938 23.9561 1.60938 51.5C1.60938 79.0599 23.9481 101.391 51.5 101.391C79.0519 101.391 101.391 79.0599 101.391 51.5C101.391 23.9561 79.0519 1.60938 51.5 1.60938Z",
    fill: "#1C344F"
  })
}));

const RemoteSupportServerErrorPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const handleNavigate = () => {
    dispatch(remoteSupportMeetingSlice.actions.resetRemoteSupport());
    navigate(-1);
  };
  return jsx(RemoteSupportLayout, {
    title: "Server Error",
    description: jsxs(Fragment, {
      children: [jsx(Typography, Object.assign({
        variant: "h4"
      }, {
        children: "The server encountered an error and could not complete your request. "
      })), jsxs(Typography, Object.assign({
        variant: "h4"
      }, {
        children: ["Please try again or contact us at ", jsx("b", {
          children: "integrationsupport@vention.cc"
        }), " or ", jsx("b", {
          children: "1-800-940-3617"
        })]
      }))]
    }),
    icon: jsx(QuestionCircleIcon, {}),
    actionNode: jsx(Button, Object.assign({
      variant: "contained",
      color: "primary",
      onClick: () => handleNavigate()
    }, {
      children: "Back to Control Center"
    }))
  });
};

const RemoteSupportPage = props => {
  var _a, _b;
  const classes = useStyles$1();
  const dispatch = useAppDispatch();
  const remoteSupportMeetingState = useAppSelector(state => state.remoteSupportMeetingReducer);
  const navigate = useNavigate();
  const {
    data: machineCloudConnected,
    isLoading: isLoadingMcConnected,
    isError: isErrorMcConnected
  } = useCheckMachineCloudConnectedQuery();
  const {
    data: tokenResponse,
    isLoading: isLoadingRailsToken,
    isError: isErrorRailsToken
  } = useGetRailsTokenQuery();
  const {
    data: serialNumberResponse,
    isLoading: isLoadingSerialNumber,
    isError: isErrorLoadingSerialNumber
  } = useGetMasterMachineSerialNumberQuery();
  const {
    data: machineAndMachineDeployment,
    isLoading: isLoadingMachineAndMachineDeployment,
    isError: isErrorMachineAndMachineDeployment
  } = useGetMachineDeploymentForMachineQuery({
    serialNumber: serialNumberResponse === null || serialNumberResponse === void 0 ? void 0 : serialNumberResponse.serialNumber,
    token: tokenResponse === null || tokenResponse === void 0 ? void 0 : tokenResponse.token
  }, {
    skip: !(serialNumberResponse === null || serialNumberResponse === void 0 ? void 0 : serialNumberResponse.serialNumber) || !(tokenResponse === null || tokenResponse === void 0 ? void 0 : tokenResponse.token)
  });
  const {
    data: clientDetail,
    isLoading: isLoadingClientDetail,
    isError: isErrorClientDetail
  } = useGetClientDetailQuery({
    serialNumber: serialNumberResponse === null || serialNumberResponse === void 0 ? void 0 : serialNumberResponse.serialNumber,
    token: tokenResponse === null || tokenResponse === void 0 ? void 0 : tokenResponse.token
  }, {
    skip: !(serialNumberResponse === null || serialNumberResponse === void 0 ? void 0 : serialNumberResponse.serialNumber) || !(tokenResponse === null || tokenResponse === void 0 ? void 0 : tokenResponse.token)
  });
  const {
    inBusinessHours,
    isLoading: isLoadingBusinessHours,
    isError: isErrorBusinessHours,
    workHours,
    displayTimeZone
  } = useInBusinessHours({
    serviceSite: (_a = machineAndMachineDeployment === null || machineAndMachineDeployment === void 0 ? void 0 : machineAndMachineDeployment.machine_deployment) === null || _a === void 0 ? void 0 : _a.service_site,
    token: tokenResponse === null || tokenResponse === void 0 ? void 0 : tokenResponse.token
  }, {
    skip: !((_b = machineAndMachineDeployment === null || machineAndMachineDeployment === void 0 ? void 0 : machineAndMachineDeployment.machine_deployment) === null || _b === void 0 ? void 0 : _b.service_site) || !(tokenResponse === null || tokenResponse === void 0 ? void 0 : tokenResponse.token)
  });
  const handleBackToControlCenter = () => {
    dispatch(remoteSupportMeetingSlice.actions.resetRemoteSupport());
    navigate(-1);
  };
  useEffect(function checkToGoBackInMeeting() {
    if (remoteSupportMeetingState.isRemoteSupportConnected) {
      dispatch(remoteSupportMeetingSlice.actions.setRemoteSupportVisible(true));
    }
  }, [remoteSupportMeetingState.isRemoteSupportConnected]);
  if (!props.isOnPendant) {
    return jsx(RemoteSupportNotOnPendantPage, {});
  }
  if (isLoadingMcConnected || isLoadingRailsToken || isLoadingClientDetail || isLoadingSerialNumber || isLoadingMachineAndMachineDeployment || isLoadingBusinessHours) {
    return jsx("div", Object.assign({
      className: classes.welcomePage
    }, {
      children: jsx(RemoteSupportLayout, {
        title: "Welcome to Vention Remote Support!",
        description: jsx(Typography, Object.assign({
          variant: "h3"
        }, {
          children: "Get on demand support from a Vention automation expert in minutes."
        })),
        actionNode: jsx("div", Object.assign({
          className: classes.spinnerContainer
        }, {
          children: jsx(CircularProgress, {
            color: "secondary",
            size: 60
          })
        })),
        icon: jsx(RemoteSupportIcon, {})
      })
    }));
  }
  if (!machineCloudConnected) {
    return jsx(RemoteSupportNoInternetPage, {});
  }
  if (isErrorMcConnected || isErrorRailsToken || isErrorMachineAndMachineDeployment || isErrorClientDetail || isErrorBusinessHours || isErrorLoadingSerialNumber || remoteSupportMeetingState.isServerError) {
    console.error("Remote Support Error", {
      isErrorMcConnected,
      isErrorRailsToken,
      isErrorMachineAndMachineDeployment,
      isErrorClientDetail,
      isErrorBusinessHours,
      isErrorLoadingSerialNumber,
      "remoteSupportMeetingState.isServerError": remoteSupportMeetingState.isServerError
    });
    return jsx(RemoteSupportServerErrorPage, {});
  }
  if (!(clientDetail === null || clientDetail === void 0 ? void 0 : clientDetail.subscription.active) && !environment.isTestingRemoteSupport) {
    return jsx(RemoteSupportNoSubscriptionPage, {});
  }
  if (!inBusinessHours && !environment.isTestingRemoteSupport) {
    return jsx(RemoteSupportNotInBusinessHoursPage, {
      workHours: workHours,
      displayTimeZone: displayTimeZone
    });
  }
  if (remoteSupportMeetingState.isConnectionInitiated && !remoteSupportMeetingState.isRemoteSupportConnected) {
    return jsxs("div", Object.assign({
      className: classes.remoteSupportConnectionPage
    }, {
      children: [jsx(CircularProgress, {
        color: "secondary",
        size: 60
      }), jsx(Typography, Object.assign({
        variant: "h2"
      }, {
        children: "Connecting you to a Vention expert"
      }))]
    }));
  }
  if (remoteSupportMeetingState.isMeetingEnded) return jsx(RemoteSupportFeedbackPage, {});
  if (remoteSupportMeetingState.isRemoteSupportConnected) return null;
  return jsx("div", Object.assign({
    className: classes.welcomePage
  }, {
    children: jsx(RemoteSupportLayout, {
      title: "Welcome to Vention Remote Support!",
      description: jsx(Typography, Object.assign({
        variant: "h3"
      }, {
        children: "Get on demand support from a Vention automation expert in minutes."
      })),
      actionNode: jsxs("div", Object.assign({
        className: classes.buttonContainer
      }, {
        children: [jsx(Button, Object.assign({
          variant: "contained",
          color: "secondary",
          onClick: () => {
            dispatch(remoteSupportMeetingSlice.actions.setConnectionInitiated(true));
          }
        }, {
          children: "Call Remote Support"
        })), jsx(Button, Object.assign({
          variant: "outlined",
          color: "secondary",
          onClick: () => {
            handleBackToControlCenter();
          }
        }, {
          children: "Back to Control Center"
        }))]
      })),
      icon: jsx(RemoteSupportIcon, {})
    })
  }));
};
const useStyles$1 = makeStyles(theme => ({
  remoteSupportConnectionPage: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(4)
  },
  buttonContainer: {
    display: "grid",
    gap: theme.spacing(2)
  },
  spinnerContainer: {
    paddingTop: theme.spacing(2)
  },
  welcomePage: {
    paddingTop: theme.spacing(40)
  }
}));

const RemoteSupportEntryButton = props => {
  const classes = useStyles();
  const getButtonText = () => {
    if (props.isInWaitingRoom) {
      return jsxs(Fragment, {
        children: ["Support", jsx("br", {}), "Meeting Pending"]
      });
    } else if (props.isInCall) {
      return jsxs(Fragment, {
        children: ["Return to", jsx("br", {}), "Support Meeting"]
      });
    }
    return jsxs(Fragment, {
      children: ["Call Remote", jsx("br", {}), "Support"]
    });
  };
  const getButtonIcon = () => {
    if (props.isInWaitingRoom) {
      return jsx(ColoredCircle, {
        color: customTheme.palette.warning.main,
        size: "medium",
        glow: true
      });
    } else if (props.isInCall) {
      return jsx(ColoredCircle, {
        color: customTheme.palette.error.main,
        size: "medium",
        glow: true
      });
    }
    return jsx(RemoteSupportIcon, {
      scale: 0.25,
      isColorFlipped: true
    });
  };
  return (
    // Because this Component will be rendered in a different tree than the remoteSupportProvider on the pendant,
    // We need to wrap this component individually with the ThemeProvider so it has access to our global mui theme.
    jsx(ThemeProvider, Object.assign({
      theme: customTheme
    }, {
      children: jsx(Button, Object.assign({
        variant: "outlined",
        startIcon: getButtonIcon(),
        className: clsx(classes.remoteSupportButton, props.isLarge && classes.largeButton),
        onClick: () => props.onClick()
      }, {
        children: jsx(Typography, Object.assign({
          className: classes.buttonText,
          variant: "h6"
        }, {
          children: getButtonText()
        }))
      }))
    }))
  );
};
const useStyles = makeStyles(theme => ({
  remoteSupportButton: {
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  largeButton: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  buttonText: {
    textAlign: "left",
    marginLeft: theme.spacing(1)
  }
}));

export { NoOneAvailableDialog, RemoteSupportEntryButton, RemoteSupportFeedbackPage, RemoteSupportNoInternetPage, RemoteSupportNoSubscriptionPage, RemoteSupportNotInBusinessHoursPage, RemoteSupportNotOnPendantPage, RemoteSupportOverlayWrapper, RemoteSupportPage, RemoteSupportProvider, RemoteSupportServerErrorPage, RemoteSupportWaitingRoomPage, remoteSupportMeetingSlice, rootReducer, store, useAppDispatch, useAppSelector };
